// import React, { useState } from "react";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";

// const ExportToExcel = () => {
//   const [students, setStudents] = useState([
//     {
//       student_id: 824,
//       roll_number: "1001242662",
//       full_name: "abhay   patel",
//       parent_mob_no: "8602652969",
//       batch_name: "Dropper B",
//       Botany: 170,
//       Chemistry: 155,
//       Physics: 155,
//       Zoology: 161,
//       Test_total_questions: 180,
//       Test_percentage: 89.03,
//       average_question_time_seconds: 0,
//       maximum_question_time_seconds: 0,
//       minimum_question_time_seconds: 0,
//       Test_total_marks: 641,
//       correct_response: 164,
//       wrong_response: 15,
//       not_attempted: 1,
//       Rank: 1,
//       Percentile: 100,
//       Test_average: 429.96,
//       Top5_average: 634.6,
//       Top10_average: 621.5,
//       "Botany Rank": 3,
//       "Botany Percentile": 98.04,
//       "Zoology Rank": 2,
//       "Zoology Percentile": 99.02,
//       "Physics Rank": 5,
//       "Physics Percentile": 96.08,
//       "Chemistry Rank": 6,
//       "Chemistry Percentile": 95.1,
//     },
//     {
//       student_id: 1775,
//       roll_number: "1001242823",
//       full_name: "Jay Kumar Raikwar",
//       parent_mob_no: "9425650091",
//       batch_name: "Dropper B",
//       Botany: 150,
//       Chemistry: 123,
//       Physics: 27,
//       Zoology: 115,
//       Test_total_questions: 180,
//       Test_percentage: 57.64,
//       average_question_time_seconds: 0,
//       maximum_question_time_seconds: 0,
//       minimum_question_time_seconds: 0,
//       Test_total_marks: 415,
//       correct_response: 116,
//       wrong_response: 49,
//       not_attempted: 15,
//       Rank: 54,
//       Percentile: 48.04,
//       Test_average: 429.96,
//       Top5_average: 634.6,
//       Top10_average: 621.5,
//       "Botany Rank": 16,
//       "Botany Percentile": 85.29,
//       "Zoology Rank": 28,
//       "Zoology Percentile": 73.53,
//       "Physics Rank": 64,
//       "Physics Percentile": 38.24,
//       "Chemistry Rank": 29,
//       "Chemistry Percentile": 72.55,
//     },
//     {
//       student_id: 1777,
//       roll_number: "1001242883",
//       full_name: "Devendra  Ahirwar",
//       parent_mob_no: "9755699497",
//       batch_name: "Dropper B",
//       Botany: 145,
//       Chemistry: 150,
//       Physics: 150,
//       Zoology: 95,
//       Test_total_questions: 180,
//       Test_percentage: 75,
//       average_question_time_seconds: 0,
//       maximum_question_time_seconds: 0,
//       minimum_question_time_seconds: 0,
//       Test_total_marks: 540,
//       correct_response: 143,
//       wrong_response: 32,
//       not_attempted: 5,
//       Rank: 21,
//       Percentile: 80.39,
//       Test_average: 429.96,
//       Top5_average: 634.6,
//       Top10_average: 621.5,
//       "Botany Rank": 19,
//       "Botany Percentile": 82.35,
//       "Zoology Rank": 40,
//       "Zoology Percentile": 61.76,
//       "Physics Rank": 6,
//       "Physics Percentile": 95.1,
//       "Chemistry Rank": 8,
//       "Chemistry Percentile": 93.14,
//     },
//     {
//       student_id: 1778,
//       roll_number: "1001242833",
//       full_name: "Alok  Sharma",
//       parent_mob_no: "9752780725",
//       batch_name: "Dropper B",
//       Botany: 98,
//       Chemistry: 75,
//       Physics: 9,
//       Zoology: 13,
//       Test_total_questions: 180,
//       Test_percentage: 27.08,
//       average_question_time_seconds: 0,
//       maximum_question_time_seconds: 0,
//       minimum_question_time_seconds: 0,
//       Test_total_marks: 195,
//       correct_response: 65,
//       wrong_response: 65,
//       not_attempted: 50,
//       Rank: 91,
//       Percentile: 11.76,
//       Test_average: 429.96,
//       Top5_average: 634.6,
//       Top10_average: 621.5,
//       "Botany Rank": 45,
//       "Botany Percentile": 56.86,
//       "Zoology Rank": 68,
//       "Zoology Percentile": 34.31,
//       "Physics Rank": 73,
//       "Physics Percentile": 29.41,
//       "Chemistry Rank": 54,
//       "Chemistry Percentile": 48.04,
//     },
//     {
//       student_id: 1779,
//       roll_number: "1001242776",
//       full_name: "Swati  Yadav",
//       parent_mob_no: "8770584528",
//       batch_name: "Dropper B",
//       Botany: 65,
//       Chemistry: 68,
//       Physics: 25,
//       Zoology: 4,
//       Test_total_questions: 180,
//       Test_percentage: 22.5,
//       average_question_time_seconds: 0,
//       maximum_question_time_seconds: 0,
//       minimum_question_time_seconds: 0,
//       Test_total_marks: 162,
//       correct_response: 49,
//       wrong_response: 34,
//       not_attempted: 97,
//       Rank: 92,
//       Percentile: 10.78,
//       Test_average: 429.96,
//       Top5_average: 634.6,
//       Top10_average: 621.5,
//       "Botany Rank": 55,
//       "Botany Percentile": 47.06,
//       "Zoology Rank": 69,
//       "Zoology Percentile": 33.33,
//       "Physics Rank": 66,
//       "Physics Percentile": 36.27,
//       "Chemistry Rank": 55,
//       "Chemistry Percentile": 47.06,
//     },
//   ]);

//   const exportToExcel = () => {
//     const ws = XLSX.utils.json_to_sheet(students);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Students");
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const data = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(data, "Students_Report.xlsx");
//   };

//   return (
//     <div>
//       <h1>Student Report</h1>
//       <button onClick={exportToExcel}>Export to Excel</button>
//       <table>
//         <thead>
//           <tr>
//             <th>student</th>

//           </tr>
//         </thead>
//         <tbody>
//           {students.map((student, index) => (
//             <tr key={index}>
//               {/* <td>{students}</td> */}

//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default ExportToExcel;

// LineChart.js

// App.js
// import React from 'react';
// import LineChart from './FileComp';

// const data = [
//   {
//     id: 'japan',
//     color: 'hsl(348, 70%, 50%)',
//     data: [
//       { x: 'plane', y: 240 },
//       { x: 'helicopter', y: 139 },
//       { x: 'boat', y: 200 },
//       { x: 'train', y: 300 },
//       { x: 'subway', y: 100 },
//       { x: 'bus', y: 80 },
//       { x: 'car', y: 150 },
//       { x: 'moto', y: 90 },
//       { x: 'bicycle', y: 50 },
//       { x: 'horse', y: 30 },
//       { x: 'skateboard', y: 20 },
//       { x: 'others', y: 10 }
//     ]
//   }
// ];

// const Pop = () => (
//   <div>
//     <h1>My Nivo Line Chart</h1>
//     <LineChart data={data} />
//   </div>
// );

// export default Pop;

// App.js

// import ReactDOM from "react-dom";
// import React from "react";
// import LineChart from "./FileComp";
// import BarChart from "./FileComp2";
// import MyPieChart from "./FileCompo3";

// const dataPie = [
//   {
//     id: "javascript",
//     label: "javascript",
//     value: 29,
//     color: "hsl(205, 70%, 50%)",
//   },
//   { id: "python", label: "python", value: 25, color: "hsl(100, 70%, 50%)" },
//   { id: "java", label: "java", value: 20, color: "hsl(50, 70%, 50%)" },
//   { id: "ruby", label: "ruby", value: 15, color: "hsl(300, 70%, 50%)" },
//   { id: "go", label: "go", value: 11, color: "hsl(150, 70%, 50%)" },
// ];
// const dataBar = [
//   {
//     country: "AD",
//     "hot dog": 147,
//     "hot dogColor": "hsl(136, 70%, 50%)",
//     burger: 158,
//     burgerColor: "hsl(295, 70%, 50%)",
//     sandwich: 163,
//     sandwichColor: "hsl(4, 70%, 50%)",
//     kebab: 117,
//     kebabColor: "hsl(225, 70%, 50%)",
//     fries: 109,
//     friesColor: "hsl(333, 70%, 50%)",
//     donut: 117,
//     donutColor: "hsl(121, 70%, 50%)",
//   },
//   {
//     country: "AE",
//     "hot dog": 92,
//     "hot dogColor": "hsl(202, 70%, 50%)",
//     burger: 118,
//     burgerColor: "hsl(36, 70%, 50%)",
//     sandwich: 103,
//     sandwichColor: "hsl(196, 70%, 50%)",
//     kebab: 146,
//     kebabColor: "hsl(112, 70%, 50%)",
//     fries: 91,
//     friesColor: "hsl(81, 70%, 50%)",
//     donut: 127,
//     donutColor: "hsl(183, 70%, 50%)",
//   },
//   {
//     country: "AF",
//     "hot dog": 196,
//     "hot dogColor": "hsl(293, 70%, 50%)",
//     burger: 5,
//     burgerColor: "hsl(23, 70%, 50%)",
//     sandwich: 63,
//     sandwichColor: "hsl(239, 70%, 50%)",
//     kebab: 23,
//     kebabColor: "hsl(85, 70%, 50%)",
//     fries: 1,
//     friesColor: "hsl(237, 70%, 50%)",
//     donut: 54,
//     donutColor: "hsl(129, 70%, 50%)",
//   },
//   {
//     country: "AG",
//     "hot dog": 168,
//     "hot dogColor": "hsl(256, 70%, 50%)",
//     burger: 32,
//     burgerColor: "hsl(84, 70%, 50%)",
//     sandwich: 177,
//     sandwichColor: "hsl(257, 70%, 50%)",
//     kebab: 69,
//     kebabColor: "hsl(262, 70%, 50%)",
//     fries: 63,
//     friesColor: "hsl(126, 70%, 50%)",
//     donut: 105,
//     donutColor: "hsl(38, 70%, 50%)",
//   },
//   {
//     country: "AI",
//     "hot dog": 106,
//     "hot dogColor": "hsl(254, 70%, 50%)",
//     burger: 47,
//     burgerColor: "hsl(359, 70%, 50%)",
//     sandwich: 46,
//     sandwichColor: "hsl(235, 70%, 50%)",
//     kebab: 77,
//     kebabColor: "hsl(104, 70%, 50%)",
//     fries: 121,
//     friesColor: "hsl(155, 70%, 50%)",
//     donut: 108,
//     donutColor: "hsl(248, 70%, 50%)",
//   },
//   {
//     country: "AL",
//     "hot dog": 47,
//     "hot dogColor": "hsl(36, 70%, 50%)",
//     burger: 14,
//     burgerColor: "hsl(56, 70%, 50%)",
//     sandwich: 169,
//     sandwichColor: "hsl(207, 70%, 50%)",
//     kebab: 80,
//     kebabColor: "hsl(290, 70%, 50%)",
//     fries: 52,
//     friesColor: "hsl(230, 70%, 50%)",
//     donut: 86,
//     donutColor: "hsl(328, 70%, 50%)",
//   },
//   {
//     country: "AM",
//     "hot dog": 82,
//     "hot dogColor": "hsl(207, 70%, 50%)",
//     burger: 13,
//     burgerColor: "hsl(178, 70%, 50%)",
//     sandwich: 85,
//     sandwichColor: "hsl(334, 70%, 50%)",
//     kebab: 192,
//     kebabColor: "hsl(58, 70%, 50%)",
//     fries: 113,
//     friesColor: "hsl(316, 70%, 50%)",
//     donut: 67,
//     donutColor: "hsl(205, 70%, 50%)",
//   },
// ];

// const data = [
//   {
//     id: "japan",
//     color: "hsl(348, 70%, 50%)",
//     data: [
//       { x: "plane", y: 240 },
//       { x: "helicopter", y: 139 },
//       { x: "boat", y: 200 },
//       { x: "train", y: 300 },
//       { x: "subway", y: 100 },
//       { x: "bus", y: 80 },
//       { x: "car", y: 150 },
//       { x: "moto", y: 90 },
//       { x: "bicycle", y: 50 },
//       { x: "horse", y: 30 },
//       { x: "skateboard", y: 20 },
//       { x: "others", y: 10 },
//     ],
//   },
//   {
//     id: "france",
//     color: "hsl(220, 70%, 50%)",
//     data: [
//       { x: "plane", y: 200 },
//       { x: "helicopter", y: 150 },
//       { x: "boat", y: 180 },
//       { x: "train", y: 250 },
//       { x: "subway", y: 120 },
//       { x: "bus", y: 90 },
//       { x: "car", y: 170 },
//       { x: "moto", y: 100 },
//       { x: "bicycle", y: 60 },
//       { x: "horse", y: 40 },
//       { x: "skateboard", y: 30 },
//       { x: "others", y: 20 },
//     ],
//   },
//   {
//     id: "germany",
//     color: "hsl(100, 70%, 50%)",
//     data: [
//       { x: "plane", y: 220 },
//       { x: "helicopter", y: 130 },
//       { x: "boat", y: 190 },
//       { x: "train", y: 270 },
//       { x: "subway", y: 110 },
//       { x: "bus", y: 85 },
//       { x: "car", y: 160 },
//       { x: "moto", y: 95 },
//       { x: "bicycle", y: 55 },
//       { x: "horse", y: 35 },
//       { x: "skateboard", y: 25 },
//       { x: "others", y: 15 },
//     ],
//   },
// ];

// const App = () => (
//   <div>
//     <h1> Line Chart</h1>
//     <LineChart data={data} />
//     <h1> Bar Chart</h1>
//     <BarChart data={dataBar} />
//     <h1> Pie Chart</h1>
//     <MyPieChart data={dataPie} />
//     {/* <PieChart data={dataPie} /> */}
//   </div>
// );

// export default App;

// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const SearchAssessments = ({ batchIds }) => {
//   const [searchKey, setSearchKey] = useState("");
//   const [assessments, setAssessments] = useState([]);
//   const [selectedAssessment, setSelectedAssessment] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const fetchAssessments = async (searchKey) => {
//     if (!searchKey || searchKey.length === 0) return; // Don't fetch if no search key is provided
//     setLoading(true);
//     try {
//       console.log("Fetching assessments for search key:", searchKey); // Debug log to check API trigger
//       const batchIdsString = batchIds.map((id) => `batch_ids=${id}`).join("&");
//       const response = await axios.get(
//         `https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-by-batch-list-searchkey/?search_key=${searchKey}&${batchIdsString}`
//       );
//       setAssessments(response.data);
//     } catch (error) {
//       console.error("Error fetching assessments", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (searchKey.trim().length > 0) {
//       const delayDebounceFn = setTimeout(() => {
//         fetchAssessments(searchKey);
//       }, 300); // Add a debounce effect to avoid too many API calls
//       return () => clearTimeout(delayDebounceFn);
//     } else {
//       setAssessments([]); // Clear the assessments if no search key is present
//     }
//   }, [searchKey]);

//   return (
//     <div>
//       <input
//         type="text"
//         value={searchKey}
//         onChange={(e) => setSearchKey(e.target.value)}
//         placeholder="Search Assessments..."
//       />
//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         assessments.length > 0 && (
//           <ul>
//             {assessments.map((assessment) => (
//               <li
//                 key={assessment.assessment_id}
//                 onClick={() => setSelectedAssessment(assessment.assessment_id)}
//               >
//                 {assessment.assessment_name}
//               </li>
//             ))}
//           </ul>
//         )
//       )}
//       {selectedAssessment && (
//         <p>Selected Assessment ID: {selectedAssessment}</p>
//       )}
//     </div>
//   );
// };

// export default SearchAssessments;

// import React from 'react'

// const pop = () => {
//   return (
//     <div>pop</div>
//   )
// }

// export default pop

// import React, { useState } from "react";
// import DropDownMultipleSearchSelection from "../../Pages/Reports/components/FieldsSearchComponent"; // Path to the component

// const Pop = () => {
//   const [selected, setSelected] = useState([]);

//   // Function to fetch options from the API
//   const fetchOptions = async (searchTerm) => {
//     const headers = {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     };

//     const body = JSON.stringify({
//       batch_ids: [],
//       assessment_ids: [],
//       subject_ids: [],
//       chapter_ids: [],
//     });

//     try {
//       const response = await fetch(
//         `https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=${searchTerm}`,
//         {
//           method: "POST",
//           headers: headers,
//           body: body,
//         }
//       );
//       const data = await response.json();

//       // Transform the response data to match the expected format of the dropdown
//       const transformedData = data.map((item) => ({
//         id: item.assessment_id,
//         Option1: item.subject,
//         Option2: item.chapter,
//         Option3: item.batch,
//         Headers1: "Subject",
//         Headers2: "Chapter",
//         Headers3: "Batch",
//       }));

//       return transformedData;
//     } catch (error) {
//       console.error("Error fetching options:", error);
//       return [];
//     }
//   };

//   return (
//     <>
//       {" "}
//       <button></button>
//       <div style={{ padding: "20px" }}>
//         <DropDownMultipleSearchSelection
//           width="400px"
//           label="Select DPP"
//           selected={selected}
//           setSelected={setSelected}
//           fetchOptions={fetchOptions}
//           customWidth="400px"
//           customTop="50px"
//           isRequired={true}
//           showSelectAll={true}
//           optionsData={[]}
//         />
//       </div>
//     </>
//   );
// };

// export default Pop;
// import React, { useState, useRef } from "react";
// import DropDownMultipleSearchSelection from "../../Pages/Reports/components/FieldsSearchComponent"; // Path to the component
// import InterogativeImg from "../../Assets/Images/CommanImages/Interogative.png";

// const Pop = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
// }) => {
//   const [selected, setSelected] = useState([]);

//   // Function to fetch options from the API
//   const fetchOptions = async (searchTerm) => {
//     const headers = {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     };

//     const body = JSON.stringify({
//       batch_ids: [],
//       assessment_ids: [],
//       subject_ids: [],
//       chapter_ids: [],
//     });

//     try {
//       const response = await fetch(
//         `https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=${searchTerm}`,
//         {
//           method: "POST",
//           headers: headers,
//           body: body,
//         }
//       );
//       const data = await response.json();

//       // Transform the response data to match the expected format of the dropdown
//       const transformedData = data.map((item) => ({
//         id: item.assessment_id,
//         Option1: item.subject,
//         Option2: item.chapter,
//         Option3: item.batch,
//         Headers1: "Subject",
//         Headers2: "Chapter",
//         Headers3: "Batch",
//       }));

//       return transformedData;
//     } catch (error) {
//       console.error("Error fetching options:", error);
//       return [];
//     }
//   };

//   // Function to handle cancel and show the message box
//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div
//         className="Container-messageBOX"
//         onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//         onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//       >
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to cancel?</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//   };

//   return (
//     <>
//       <button onClick={handleCancel}>Cancel</button>
//       <div style={{ padding: "20px" }}>
//         <DropDownMultipleSearchSelection
//           width="400px"
//           label="Select DPP"
//           selected={selected}
//           setSelected={setSelected}
//           fetchOptions={fetchOptions}
//           customWidth="400px"
//           customTop="50px"
//           isRequired={true}
//           showSelectAll={true}
//           optionsData={[]}
//         />
//       </div>
//     </>
//   );
// };

// export default Pop;

// [
//   {
//     assessment_id: 1,
//     assessment_assignment_id: 180,
//     assessment_type_id: 1,
//     course_name: "NEET",
//     batch_id: 2,
//     batch_name: "EL-Sankalp-NEET",
//     subject_id: 1,
//     subject_name: "Physics",
//     chapter_id: 33,
//     chapter_name: "Physical World",
//     assessment_name: "DPP110",
//   },
//   {
//     assessment_id: 1,
//     assessment_assignment_id: 148,
//     assessment_type_id: 1,
//     course_name: "NEET",
//     batch_id: 2,
//     batch_name: "EL-Sankalp-NEET",
//     subject_id: 1,
//     subject_name: "Physics",
//     chapter_id: 33,
//     chapter_name: "Physical World",
//     assessment_name: "DPP110",
//   },
//   {
//     assessment_id: 1,
//     assessment_assignment_id: 135,
//     assessment_type_id: 1,
//     course_name: "NEET",
//     batch_id: 2,
//     batch_name: "EL-Sankalp-NEET",
//     subject_id: 1,
//     subject_name: "Physics",
//     chapter_id: 33,
//     chapter_name: "Physical World",
//     assessment_name: "DPP110",
//   },
//   {
//     assessment_id: 1,
//     assessment_assignment_id: 179,
//     assessment_type_id: 1,
//     course_name: "NEET",
//     batch_id: 2,
//     batch_name: "EL-Sankalp-NEET",
//     subject_id: 1,
//     subject_name: "Physics",
//     chapter_id: 33,
//     chapter_name: "Physical World",
//     assessment_name: "DPP110",
//   },
//   {
//     assessment_id: 2,
//     assessment_assignment_id: 147,
//     assessment_type_id: 1,
//     course_name: "NEET",
//     batch_id: 2,
//     batch_name: "EL-Sankalp-NEET",
//     subject_id: 1,
//     subject_name: "Physics",
//     chapter_id: 34,
//     chapter_name: "Units And Measurements",
//     assessment_name: "DPT/NEET/12/1",
//   },
//   {
//     assessment_id: 2,
//     assessment_assignment_id: 145,
//     assessment_type_id: 1,
//     course_name: "NEET",
//     batch_id: 2,
//     batch_name: "EL-Sankalp-NEET",
//     subject_id: 1,
//     subject_name: "Physics",
//     chapter_id: 34,
//     chapter_name: "Units And Measurements",
//     assessment_name: "DPT/NEET/12/1",
//   },
// ];

// import React, { useState, useEffect } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent"; // Import your child component
// import axios from "axios";

// export default function ParentComponent() {
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [batchOptions, setBatchOptions] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [subjectOptions, setSubjectOptions] = useState([]);

//   // Function to fetch batch data from API
//   const fetchBatchOptions = async () => {
//     try {
//       const response = await axios.post(
//         `https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=&search_column=`,
//         {
//           batch_ids: [], // No batch IDs sent initially
//           assessment_ids: [],
//           subject_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data;

//       // Merge unique batches
//       const uniqueBatches = mergeBatchOptions(data);

//       // Update state with batch options
//       setBatchOptions(uniqueBatches);
//     } catch (error) {
//       console.error("Error fetching batches:", error);
//     }
//   };

//   // Function to fetch subject data from API
//   const fetchSubjectOptions = async (batchIds = []) => {
//     try {
//       const response = await axios.post(
//         `https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=&search_column=`,
//         {
//           batch_ids: batchIds, // Pass selected batch IDs (if available)
//           assessment_ids: [],
//           subject_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data;

//       // Merge unique subjects
//       const uniqueSubjects = mergeSubjectOptions(data);

//       // Update state with subject options
//       setSubjectOptions(uniqueSubjects);
//     } catch (error) {
//       console.error("Error fetching subjects:", error);
//     }
//   };

//   // Function to merge unique batch options
//   const mergeBatchOptions = (data) => {
//     const batchMap = new Map();

//     data.forEach((item) => {
//       if (!batchMap.has(item.batch_id)) {
//         batchMap.set(item.batch_id, {
//           id: item.batch_id,
//           label: `${item.batch_name}`, // Use batch_name
//         });
//       }
//     });

//     return Array.from(batchMap.values()); // Return unique batches
//   };

//   // Function to merge unique subject options
//   const mergeSubjectOptions = (data) => {
//     const subjectMap = new Map();

//     data.forEach((item) => {
//       if (!subjectMap.has(item.subject_id)) {
//         subjectMap.set(item.subject_id, {
//           id: item.subject_id,
//           label: `${item.subject_name}`, // Use subject_name
//         });
//       }
//     });

//     return Array.from(subjectMap.values()); // Return unique subjects
//   };

//   // When batch selection changes, update selected batches and refetch subjects
//   const handleSelectedBatches = (selectedIds) => {
//     setSelectedBatches(selectedIds);

//     // Fetch subjects based on selected batch IDs
//     fetchSubjectOptions(selectedIds);
//   };

//   const handleSelectedSubjects = (selectedIds) => {
//     setSelectedSubjects(selectedIds);
//   };

//   const handleSubmit = async () => {
//     try {
//       const response = await axios.post(
//         "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/your-endpoint",
//         {
//           batch_ids: selectedBatches,
//           subject_ids: selectedSubjects,
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       console.log("Response:", response.data);
//     } catch (error) {
//       console.error("Error submitting selected batches and subjects:", error);
//     }
//   };

//   // Fetch batch and subject data on component mount
//   useEffect(() => {
//     fetchBatchOptions(); // Fetch batches on mount
//     fetchSubjectOptions(); // Fetch subjects on mount (without batch_ids)
//   }, []); // Empty dependency array means this useEffect will only run once after the component mounts

//   return (
//     <div style={{ padding: "20px" }}>
//       <h1>Select Batches and Subjects</h1>

//       {/* DropDownMultipleSelection for Batches */}
//       <DropDownMultipleSelection
//         width="300px"
//         customWidth="50vw"
//         label="Select Batches"
//         selected={selectedBatches}
//         setSelected={handleSelectedBatches}
//         options={batchOptions}
//         showSelectAll={true}
//       />

//       {/* DropDownMultipleSelection for Subjects */}
//       <DropDownMultipleSelection
//         width="300px"
//         customWidth="50vw"
//         label="Select Subjects"
//         selected={selectedSubjects}
//         setSelected={handleSelectedSubjects}
//         options={subjectOptions}
//         showSelectAll={true}
//       />

//       <button onClick={handleSubmit}>
//         Submit Selected Batches and Subjects
//       </button>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent"; // Import your child component
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent"; // Import your child component
// import axios from "axios";

// export default function ParentComponent() {
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [batchOptions, setBatchOptions] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [subjectOptions, setSubjectOptions] = useState([]);
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [chapterOptions, setChapterOptions] = useState([]);
//   // Function to fetch batch and subject data from API, optionally using selected batch_ids
//   const fetchBatchOptions = async (batchIds = []) => {
//     try {
//       const response = await axios.post(
//         `https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=&search_column=`,
//         {
//           batch_ids: batchIds, // Send selected batch IDs
//           assessment_ids: [],
//           subject_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data;

//       // Merge unique batches and subjects
//       const { uniqueBatches, uniqueSubjects } = mergeOptions(data);

//       // Update state with merged and filtered data
//       setBatchOptions(uniqueBatches);
//       setSubjectOptions(uniqueSubjects);
//     } catch (error) {
//       console.error("Error fetching batches and subjects:", error);
//     }
//   };

//   // Function to merge unique batch and subject options
//   const mergeOptions = (data) => {
//     const batchMap = new Map();
//     const subjectMap = new Map();

//     data.forEach((item) => {
//       // Handle unique batches
//       if (!batchMap.has(item.batch_id)) {
//         batchMap.set(item.batch_id, {
//           id: item.batch_id,
//           label: `${item.batch_name}`, // Use batch_name
//         });
//       }

//       // Handle unique subjects
//       if (!subjectMap.has(item.subject_id)) {
//         subjectMap.set(item.subject_id, {
//           id: item.subject_id,
//           label: `${item.subject_name}`, // Use subject_name
//         });
//       }
//     });

//     return {
//       uniqueBatches: Array.from(batchMap.values()), // Unique batches
//       uniqueSubjects: Array.from(subjectMap.values()), // Unique subjects
//     };
//   };

//   // When batch selection changes, refetch data with the selected batch IDs
//   const handleSelectedBatches = (selectedIds) => {
//     setSelectedBatches(selectedIds);

//     // Fetch new data based on selected batch IDs
//     fetchBatchOptions(selectedIds);
//   };

//   const handleSelectedSubjects = (selectedIds) => {
//     setSelectedSubjects(selectedIds);
//   };
//   const fetchChapterOptions = async (searchTerm) => {
//     if (searchTerm.length < 3) {
//       console.log("Search term must be at least 3 characters");
//       return []; // Do not fetch if search term is less than 3 characters
//     }

//     try {
//       console.log("Fetching chapters with search term:", searchTerm);

//       const response = await axios.post(
//         `https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=${searchTerm}&search_column=chapter`,
//         {
//           batch_ids: [],
//           assessment_ids: [],
//           subject_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data;
//       console.log("API response data:", data);

//       // Merge chapter IDs (ensure unique chapter IDs)
//       const mergedChapters = mergeChapterOptions(data);
//       console.log("Merged chapter options:", mergedChapters);

//       // Filter options based on search term
//       const filteredChapters = mergedChapters.filter((option) =>
//         option.Option1.toLowerCase().includes(searchTerm.toLowerCase())
//       );

//       console.log("Filtered chapter options:", filteredChapters);
//       return filteredChapters;
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//       return [];
//     }
//   };

//   // Function to merge chapters with the same chapter ID
//   const mergeChapterOptions = (data) => {
//     const chapterMap = new Map();

//     data.forEach((item) => {
//       if (!chapterMap.has(item.chapter_id)) {
//         chapterMap.set(item.chapter_id, {
//           id: item.chapter_id,
//           Option1: item.chapter_name,
//           Option2: item.batch_name,
//           Option3: item.subject_name,
//           Headers1: "Chapter Name",
//           Headers2: "Batch Name",
//           Headers3: "Subject Name",
//         });
//       }
//     });

//     return Array.from(chapterMap.values());
//   };

//   const handleSelectedChapters = (selectedIds) => {
//     // Update selected chapter IDs
//     console.log("Selected chapter IDs:", selectedIds);
//     setSelectedChapters(selectedIds);
//   };

//   const handleSubmit = async () => {
//     try {
//       const response = await axios.post(
//         "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/your-endpoint",
//         {
//           batch_ids: selectedBatches,
//           subject_ids: selectedSubjects,
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       console.log("Response:", response.data);
//     } catch (error) {
//       console.error("Error submitting selected batches and subjects:", error);
//     }
//   };

//   // Fetch initial data on component mount
//   useEffect(() => {
//     fetchBatchOptions(); // Fetch data without any batch_ids initially
//   }, []); // Empty dependency array means this useEffect will only run once after the component mounts

//   return (
//     <div style={{ padding: "20px" }}>
//       <h1>Select Batches and Subjects</h1>

//       {/* DropDownMultipleSelection for Batches */}
//       <DropDownMultipleSelection
//         width="300px"
//         customWidth="50vw"
//         label="Select Batches"
//         selected={selectedBatches}
//         setSelected={handleSelectedBatches}
//         options={batchOptions}
//         showSelectAll={true}
//       />

//       {/* DropDownMultipleSelection for Subjects */}
//       <DropDownMultipleSelection
//         width="300px"
//         customWidth="50vw"
//         label="Select Subjects"
//         selected={selectedSubjects}
//         setSelected={handleSelectedSubjects}
//         options={subjectOptions}
//         showSelectAll={true}
//       />

//       <DropDownMultipleSearchSelection
//         width="13.5vw"
//         customWidth="25vw"
//         label="Select Chapters"
//         selected={selectedChapters}
//         setSelected={handleSelectedChapters}
//         fetchOptions={fetchChapterOptions}
//         showSelectAll={true}
//         optionsData={chapterOptions}
//       />
//       <button onClick={handleSubmit}>
//         Submit Selected Batches and Subjects
//       </button>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent"; // Import your child component
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent"; // Import your child component
// import axios from "axios";

// export default function ParentComponent() {
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [batchOptions, setBatchOptions] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [subjectOptions, setSubjectOptions] = useState([]);
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [chapterOptions, setChapterOptions] = useState([]);

//   // Function to fetch batch and subject data from API, using selected batch_ids and subject_ids
//   const fetchBatchOptions = async (batchIds = [], subjectIds = []) => {
//     try {
//       const response = await axios.post(
//         `https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=&search_column=`,
//         {
//           batch_ids: batchIds, // Send selected batch IDs
//           subject_ids: subjectIds, // Send selected subject IDs
//           assessment_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data;

//       // Merge unique batches and subjects
//       const { uniqueBatches, uniqueSubjects } = mergeOptions(data);

//       // Update state with merged and filtered data
//       setBatchOptions(uniqueBatches);
//       setSubjectOptions(uniqueSubjects);
//     } catch (error) {
//       console.error("Error fetching batches and subjects:", error);
//     }
//   };

//   // Function to merge unique batch and subject options
//   const mergeOptions = (data) => {
//     const batchMap = new Map();
//     const subjectMap = new Map();

//     data.forEach((item) => {
//       // Handle unique batches
//       if (!batchMap.has(item.batch_id)) {
//         batchMap.set(item.batch_id, {
//           id: item.batch_id,
//           label: `${item.batch_name}`, // Use batch_name
//         });
//       }

//       // Handle unique subjects
//       if (!subjectMap.has(item.subject_id)) {
//         subjectMap.set(item.subject_id, {
//           id: item.subject_id,
//           label: `${item.subject_name}`, // Use subject_name
//         });
//       }
//     });

//     return {
//       uniqueBatches: Array.from(batchMap.values()), // Unique batches
//       uniqueSubjects: Array.from(subjectMap.values()), // Unique subjects
//     };
//   };

//   // Function to fetch chapters with a search term, considering selected batch_ids and subject_ids
//   const fetchChapterOptions = async (searchTerm) => {
//     if (searchTerm.length < 3) {
//       console.log("Search term must be at least 3 characters");
//       return []; // Do not fetch if search term is less than 3 characters
//     }

//     try {
//       console.log("Fetching chapters with search term:", searchTerm);

//       const response = await axios.post(
//         `https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=1&search_key=${searchTerm}&search_column=chapter`,
//         {
//           batch_ids: selectedBatches, // Use selected batches
//           subject_ids: selectedSubjects, // Use selected subjects
//           assessment_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data;
//       console.log("API response data:", data);

//       // Merge chapter IDs (ensure unique chapter IDs)
//       const mergedChapters = mergeChapterOptions(data);
//       console.log("Merged chapter options:", mergedChapters);

//       // Filter options based on search term
//       const filteredChapters = mergedChapters.filter((option) =>
//         option.Option1.toLowerCase().includes(searchTerm.toLowerCase())
//       );

//       console.log("Filtered chapter options:", filteredChapters);
//       setChapterOptions(filteredChapters); // Update chapter options in the state
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//       return [];
//     }
//   };

//   // Function to merge chapters with the same chapter ID
//   const mergeChapterOptions = (data) => {
//     const chapterMap = new Map();

//     data.forEach((item) => {
//       if (!chapterMap.has(item.chapter_id)) {
//         chapterMap.set(item.chapter_id, {
//           id: item.chapter_id,
//           Option1: item.chapter_name,
//           Option2: item.batch_name,
//           Option3: item.subject_name,
//           Headers1: "Chapter Name",
//           Headers2: "Batch Name",
//           Headers3: "Subject Name",
//         });
//       }
//     });

//     return Array.from(chapterMap.values());
//   };

//   // When batch selection changes, refetch data with the selected batch IDs and subject IDs
//   const handleSelectedBatches = (selectedIds) => {
//     setSelectedBatches(selectedIds);

//     // Fetch new data based on selected batch and subject IDs
//     fetchBatchOptions(selectedIds, selectedSubjects);
//   };

//   // When subject selection changes, refetch data with the selected subject IDs and batch IDs
//   const handleSelectedSubjects = (selectedIds) => {
//     setSelectedSubjects(selectedIds);

//     // Fetch new data based on selected subject and batch IDs
//     fetchBatchOptions(selectedBatches, selectedIds);
//   };

//   const handleSelectedChapters = (selectedIds) => {
//     // Update selected chapter IDs
//     console.log("Selected chapter IDs:", selectedIds);
//     setSelectedChapters(selectedIds);
//   };

//   const handleSubmit = async () => {
//     try {
//       const response = await axios.post(
//         "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/your-endpoint",
//         {
//           batch_ids: selectedBatches,
//           subject_ids: selectedSubjects,
//           chapter_ids: selectedChapters,
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       console.log("Response:", response.data);
//     } catch (error) {
//       console.error("Error submitting selected batches, subjects, and chapters:", error);
//     }
//   };

//   // Fetch initial data on component mount
//   useEffect(() => {
//     fetchBatchOptions(); // Fetch data without any batch_ids or subject_ids initially
//   }, []); // Empty dependency array means this useEffect will only run once after the component mounts

//   return (
//     <div style={{ padding: "20px" }}>
//       <h1>Select Batches, Subjects, and Chapters</h1>

//       {/* DropDownMultipleSelection for Batches */}
//       <DropDownMultipleSelection
//         width="300px"
//         customWidth="50vw"
//         label="Select Batches"
//         selected={selectedBatches}
//         setSelected={handleSelectedBatches}
//         options={batchOptions}
//         showSelectAll={true}
//       />

//       {/* DropDownMultipleSelection for Subjects */}
//       <DropDownMultipleSelection
//         width="300px"
//         customWidth="50vw"
//         label="Select Subjects"
//         selected={selectedSubjects}
//         setSelected={handleSelectedSubjects}
//         options={subjectOptions}
//         showSelectAll={true}
//       />

//       {/* DropDownMultipleSearchSelection for Chapters */}
//       <DropDownMultipleSearchSelection
//         width="13.5vw"
//         customWidth="25vw"
//         label="Select Chapters"
//         selected={selectedChapters}
//         setSelected={handleSelectedChapters}
//         fetchOptions={fetchChapterOptions}
//         showSelectAll={true}
//         optionsData={chapterOptions}
//       />

//       <button onClick={handleSubmit}>
//         Submit Selected Batches, Subjects, and Chapters
//       </button>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import Swal from "sweetalert2";
// import axios from "axios";

// const DPPPerformance = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const [subjectData, setSubjectData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [apiData, setApiData] = useState([]); // Store full API data
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [chapterOptions, setChapterOptions] = useState([]);
//   const [value, setValues] = useState({
//     course_id: "", // course_id will be selected from dropdown
//   });

//   useEffect(() => {
//     if (value.course_id) {
//       fetchSubjectsAndBatchesByCourse();
//     }
//   }, [value.course_id]);

//   useEffect(() => {
//     if (selectedBatches.length > 0) {
//       filterSubjectsByBatch();
//     } else if (selectedSubjects.length > 0) {
//       filterBatchesBySubject();
//     } else {
//       resetFilters();
//     }
//   }, [selectedBatches, selectedSubjects]);

//   const fetchSubjectsAndBatchesByCourse = async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=${value.course_id}`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: [], // Initially empty, can be filled if needed
//             assessment_ids: [],
//             subject_ids: [],
//             chapter_ids: [],
//           }),
//         }
//       );
//       const data = await response.json();
//       setApiData(data); // Store full API data

//       // Extract unique batches and subjects
//       const uniqueBatches = [];
//       const uniqueSubjects = [];

//       data.forEach((item) => {
//         if (!uniqueBatches.find((batch) => batch.id === item.batch_id)) {
//           uniqueBatches.push({ label: item.batch_name, id: item.batch_id });
//         }
//         if (!uniqueSubjects.find((subject) => subject.id === item.subject_id)) {
//           uniqueSubjects.push({
//             label: item.subject_name,
//             id: item.subject_id,
//           });
//         }
//       });

//       setBatchData(uniqueBatches);
//       setFilteredBatches(uniqueBatches); // Initially show all batches
//       setSubjectData(uniqueSubjects);
//       setFilteredSubjects(uniqueSubjects); // Initially show all subjects
//     } catch (error) {
//       Swal.fire({
//         title: "Error",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const filterSubjectsByBatch = () => {
//     const filtered = apiData
//       .filter((item) => selectedBatches.includes(item.batch_id))
//       .map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));

//     const uniqueFilteredSubjects = filtered.filter(
//       (value, index, self) =>
//         index === self.findIndex((subject) => subject.id === value.id)
//     ); // Ensure subjects are unique
//     setFilteredSubjects(uniqueFilteredSubjects);
//   };

//   const filterBatchesBySubject = () => {
//     const filtered = apiData
//       .filter((item) => selectedSubjects.includes(item.subject_id))
//       .map((item) => ({
//         label: item.batch_name,
//         id: item.batch_id,
//       }));

//     const uniqueFilteredBatches = filtered.filter(
//       (value, index, self) =>
//         index === self.findIndex((batch) => batch.id === value.id)
//     ); // Ensure batches are unique
//     setFilteredBatches(uniqueFilteredBatches);
//   };

//   const resetFilters = () => {
//     setFilteredBatches(batchData); // Reset to show all batches
//     setFilteredSubjects(subjectData); // Reset to show all subjects
//   };

//   const fetchChapterOptions = async (searchTerm) => {
//     if (searchTerm.length < 3) {
//       console.log("Search term must be at least 3 characters");
//       return []; // Do not fetch if search term is less than 3 characters
//     }

//     try {
//       console.log("Fetching chapters with search term:", searchTerm);

//       const response = await axios.post(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=1&search_key=${searchTerm}&search_column=chapter`,
//         {
//           batch_ids: [],
//           assessment_ids: [],
//           subject_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data;
//       console.log("API response data:", data);

//       // Merge chapter IDs (ensure unique chapter IDs)
//       const mergedChapters = mergeChapterOptions(data);
//       console.log("Merged chapter options:", mergedChapters);

//       // Filter options based on search term
//       const filteredChapters = mergedChapters.filter((option) =>
//         option.Option1.toLowerCase().includes(searchTerm.toLowerCase())
//       );

//       console.log("Filtered chapter options:", filteredChapters);
//       return filteredChapters;
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//       return [];
//     }
//   };

//   // Function to merge chapters with the same chapter ID
//   const mergeChapterOptions = (data) => {
//     const chapterMap = new Map();

//     data.forEach((item) => {
//       if (!chapterMap.has(item.chapter_id)) {
//         chapterMap.set(item.chapter_id, {
//           id: item.chapter_id,
//           Option1: item.chapter_name,
//           Option2: item.batch_name,
//           Option3: item.subject_name,
//           Headers1: "Chapter Name",
//           Headers2: "Batch Name",
//           Headers3: "Subject Name",
//         });
//       }
//     });

//     return Array.from(chapterMap.values());
//   };

//   const handleSelectedChapters = (selectedIds) => {
//     // Update selected chapter IDs
//     console.log("Selected chapter IDs:", selectedIds);
//     setSelectedChapters(selectedIds);
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <div>
//         {/* Course dropdown */}
//         <DropDownMultipleSelection
//           label="Course"
//           width="13.5vw"
//           selected={value.course_id}
//           setSelected={(selectedOption) =>
//             setValues({ ...value, course_id: selectedOption })
//           }
//           options={[
//             { label: "NEET", id: 1 },
//             { label: "JEE", id: 2 },
//             // Add more courses as needed
//           ]}
//         />
//       </div>

//       {/* Batch Dropdown */}
//       <DropDownMultipleSelection
//         label="Batch"
//         width="13.5vw"
//         selected={selectedBatches}
//         setSelected={setSelectedBatches}
//         options={filteredBatches} // Filtered batch data
//         showSelectAll={true}
//       />

//       {/* Subject Dropdown */}
//       <DropDownMultipleSelection
//         label="Subject"
//         width="13.5vw"
//         selected={selectedSubjects}
//         setSelected={setSelectedSubjects}
//         options={filteredSubjects} // Filtered subject data
//         showSelectAll={true}
//       />

//       <DropDownMultipleSearchSelection
//         width="13.5vw"
//         customWidth="25vw"
//         label="Select Chapters"
//         selected={selectedChapters}
//         setSelected={handleSelectedChapters}
//         fetchOptions={fetchChapterOptions}
//         showSelectAll={true}
//         optionsData={chapterOptions}
//       />
//     </div>
//   );
// };

// export default DPPPerformance;

// import React, { useState, useEffect, useCallback } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import Swal from "sweetalert2";
// import axios from "axios";

// const POP = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const [subjectData, setSubjectData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [apiData, setApiData] = useState([]); // Store full API data
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [chapterOptions, setChapterOptions] = useState([]); // Initialize with an empty array
//   const [value, setValues] = useState({
//     course_id: "", // course_id will be selected from dropdown
//   });

//   // Use `useCallback` to ensure fetchData is not recreated on every render
//   const fetchData = useCallback(
//     async (searchKey = "", searchColumn = "") => {
//       if (!value.course_id) return; // Only run if course_id is selected

//       try {
//         const body = {
//           batch_ids: searchColumn === "chapter" ? selectedBatches : [],
//           subject_ids: searchColumn === "chapter" ? selectedSubjects : [],
//           assessment_ids: [],
//           chapter_ids: [],
//         };

//         const response = await axios.post(
//           `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=${value.course_id}&search_key=${searchKey}&search_column=${searchColumn}`,
//           body,
//           {
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const data = response.data;
//         setApiData(data || []); // Ensure apiData is always an array

//         if (searchColumn === "") {
//           // If not filtering for chapters, set batch and subject data
//           const uniqueBatches = [];
//           const uniqueSubjects = [];

//           data.forEach((item) => {
//             if (!uniqueBatches.find((batch) => batch.id === item.batch_id)) {
//               uniqueBatches.push({ label: item.batch_name, id: item.batch_id });
//             }
//             if (!uniqueSubjects.find((subject) => subject.id === item.subject_id)) {
//               uniqueSubjects.push({
//                 label: item.subject_name,
//                 id: item.subject_id,
//               });
//             }
//           });

//           setBatchData(uniqueBatches);
//           setFilteredBatches(uniqueBatches); // Initially show all batches
//           setSubjectData(uniqueSubjects);
//           setFilteredSubjects(uniqueSubjects); // Initially show all subjects
//         } else if (searchColumn === "chapter") {
//           // Handle chapters
//           const mergedChapters = mergeChapterOptions(data || []); // Ensure data is an array
//           setChapterOptions(mergedChapters); // Set chapter options
//         }
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     },
//     [value.course_id, selectedBatches, selectedSubjects]
//   );

//   // Fetch chapters based on search term
//   const fetchChapterOptions = async (searchTerm) => {
//     if (searchTerm.length < 3) {
//       console.log("Search term must be at least 3 characters");
//       return []; // Do not fetch if search term is less than 3 characters
//     }

//     try {
//       console.log("Fetching chapters with search term:", searchTerm);

//       const response = await axios.post(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=${value.course_id}&search_key=${searchTerm}&search_column=chapter`,
//         {
//           batch_ids: selectedBatches, // Pass batch_ids for context
//           subject_ids: selectedSubjects, // Pass subject_ids for context
//           assessment_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data || []; // Ensure data is an array

//       const mergedChapters = mergeChapterOptions(data);
//       console.log("Merged chapter options:", mergedChapters);

//       return mergedChapters;
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//       return [];
//     }
//   };

//   // Function to merge chapters with the same chapter ID
//   const mergeChapterOptions = (data) => {
//     const chapterMap = new Map();

//     data.forEach((item) => {
//       if (!chapterMap.has(item.chapter_id)) {
//         chapterMap.set(item.chapter_id, {
//           id: item.chapter_id,
//           Option1: item.chapter_name,
//           Option2: item.batch_name,
//           Option3: item.subject_name,
//           Headers1: "Chapter Name",
//           Headers2: "Batch Name",
//           Headers3: "Subject Name",
//         });
//       }
//     });

//     return Array.from(chapterMap.values());
//   };

//   const handleSelectedChapters = (selectedIds) => {
//     console.log("Selected chapter IDs:", selectedIds);
//     setSelectedChapters(selectedIds);
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <div>
//         {/* Course dropdown */}
//         <DropDownMultipleSelection
//           label="Course"
//           width="13.5vw"
//           selected={value.course_id}
//           setSelected={(selectedOption) =>
//             setValues({ ...value, course_id: selectedOption })
//           }
//           options={[
//             { label: "NEET", id: 1 },
//             { label: "JEE", id: 2 },
//             // Add more courses as needed
//           ]}
//         />
//       </div>

//       {/* Batch Dropdown */}
//       <DropDownMultipleSelection
//         label="Batch"
//         width="13.5vw"
//         selected={selectedBatches}
//         setSelected={setSelectedBatches}
//         options={filteredBatches} // Filtered batch data
//         showSelectAll={true}
//       />

//       {/* Subject Dropdown */}
//       <DropDownMultipleSelection
//         label="Subject"
//         width="13.5vw"
//         selected={selectedSubjects}
//         setSelected={setSelectedSubjects}
//         options={filteredSubjects} // Filtered subject data
//         showSelectAll={true}
//       />

//       {/* Chapter Dropdown */}
//       <DropDownMultipleSearchSelection
//         width="13.5vw"
//         customWidth="25vw"
//         label="Select Chapters"
//         selected={selectedChapters}
//         setSelected={handleSelectedChapters}
//         fetchOptions={fetchChapterOptions} // Use the fetchChapterOptions for search
//         showSelectAll={true}
//         optionsData={chapterOptions} // Pass chapterOptions as data
//       />
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useEffect, useCallback } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import Swal from "sweetalert2";
// import axios from "axios";

// const POP = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const [subjectData, setSubjectData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [apiData, setApiData] = useState([]); // Store full API data
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [chapterOptions, setChapterOptions] = useState([]); // Initialize with an empty array
//   const [value, setValues] = useState({
//     course_id: "", // course_id will be selected from dropdown
//   });

//   // Use `useCallback` to ensure fetchData is not recreated on every render
//   const fetchData = useCallback(
//     async (searchKey = "", searchColumn = "") => {
//       if (!value.course_id) return; // Only run if course_id is selected

//       try {
//         const body = {
//           batch_ids: searchColumn === "chapter" ? selectedBatches : [],
//           subject_ids: searchColumn === "chapter" ? selectedSubjects : [],
//           assessment_ids: [],
//           chapter_ids: [],
//         };

//         const response = await axios.post(
//           `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=${value.course_id}&search_key=${searchKey}&search_column=${searchColumn}`,
//           body,
//           {
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const data = response.data;
//         setApiData(data || []); // Ensure apiData is always an array

//         if (searchColumn === "") {
//           // If not filtering for chapters, set batch and subject data
//           const uniqueBatches = [];
//           const uniqueSubjects = [];

//           data.forEach((item) => {
//             if (!uniqueBatches.find((batch) => batch.id === item.batch_id)) {
//               uniqueBatches.push({ label: item.batch_name, id: item.batch_id });
//             }
//             if (!uniqueSubjects.find((subject) => subject.id === item.subject_id)) {
//               uniqueSubjects.push({
//                 label: item.subject_name,
//                 id: item.subject_id,
//               });
//             }
//           });

//           setBatchData(uniqueBatches);
//           setFilteredBatches(uniqueBatches); // Initially show all batches
//           setSubjectData(uniqueSubjects);
//           setFilteredSubjects(uniqueSubjects); // Initially show all subjects
//         } else if (searchColumn === "chapter") {
//           // Handle chapters
//           const mergedChapters = mergeChapterOptions(data || []); // Ensure data is an array
//           setChapterOptions(mergedChapters); // Set chapter options
//         }
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     },
//     [value.course_id, selectedBatches, selectedSubjects]
//   );

//   // Fetch chapters based on search term
//   const fetchChapterOptions = async (searchTerm) => {
//     if (searchTerm.length < 3) {
//       console.log("Search term must be at least 3 characters");
//       return []; // Do not fetch if search term is less than 3 characters
//     }

//     try {
//       console.log("Fetching chapters with search term:", searchTerm);

//       const response = await axios.post(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=${value.course_id}&search_key=${searchTerm}&search_column=chapter`,
//         {
//           batch_ids: selectedBatches, // Pass batch_ids for context
//           subject_ids: selectedSubjects, // Pass subject_ids for context
//           assessment_ids: [],
//           chapter_ids: [],
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const data = response.data || []; // Ensure data is an array

//       const mergedChapters = mergeChapterOptions(data);
//       console.log("Merged chapter options:", mergedChapters);

//       return mergedChapters;
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//       return [];
//     }
//   };

//   // Function to merge chapters with the same chapter ID
//   const mergeChapterOptions = (data) => {
//     const chapterMap = new Map();

//     data.forEach((item) => {
//       if (!chapterMap.has(item.chapter_id)) {
//         chapterMap.set(item.chapter_id, {
//           id: item.chapter_id,
//           Option1: item.chapter_name,
//           Option2: item.batch_name,
//           Option3: item.subject_name,
//           Headers1: "Chapter Name",
//           Headers2: "Batch Name",
//           Headers3: "Subject Name",
//         });
//       }
//     });

//     return Array.from(chapterMap.values());
//   };

//   const handleSelectedChapters = (selectedIds) => {
//     console.log("Selected chapter IDs:", selectedIds);
//     setSelectedChapters(selectedIds);
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <div>
//         {/* Course dropdown */}
//         <DropDownMultipleSelection
//           label="Course"
//           width="13.5vw"
//           selected={value.course_id}
//           setSelected={(selectedOption) =>
//             setValues({ ...value, course_id: selectedOption })
//           }
//           options={[
//             { label: "NEET", id: 1 },
//             { label: "JEE", id: 2 },
//             // Add more courses as needed
//           ]}
//         />
//       </div>

//       {/* Batch Dropdown */}
//       <DropDownMultipleSelection
//         label="Batch"
//         width="13.5vw"
//         selected={selectedBatches}
//         setSelected={setSelectedBatches}
//         options={filteredBatches} // Filtered batch data
//         showSelectAll={true}
//       />

//       {/* Subject Dropdown */}
//       <DropDownMultipleSelection
//         label="Subject"
//         width="13.5vw"
//         selected={selectedSubjects}
//         setSelected={setSelectedSubjects}
//         options={filteredSubjects} // Filtered subject data
//         showSelectAll={true}
//       />

//       {/* Chapter Dropdown */}
//       <DropDownMultipleSearchSelection
//         width="13.5vw"
//         customWidth="25vw"
//         label="Select Chapters"
//         selected={selectedChapters}
//         setSelected={handleSelectedChapters}
//         fetchOptions={fetchChapterOptions} // Use the fetchChapterOptions for search
//         showSelectAll={true}
//         optionsData={chapterOptions} // Pass chapterOptions as data
//       />
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useEffect, useCallback } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import Swal from "sweetalert2";
// import axios from "axios";

// const POP = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const [subjectData, setSubjectData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [apiData, setApiData] = useState([]); // Store full API data
//   const [selectedChapters, setSelectedChapters] = useState([]); // Ensure this is initialized as an empty array
//   const [chapterOptions, setChapterOptions] = useState([]); // Initialize with an empty array
//   const [value, setValues] = useState({
//     course_id: "", // course_id will be selected from dropdown
//   });

//   // Use `useCallback` to ensure fetchData is not recreated on every render
//   const fetchData = useCallback(
//     async (searchKey = "", searchColumn = "") => {
//       if (!value.course_id) return; // Only run if course_id is selected

//       try {
//         const body = {
//           batch_ids: searchColumn === "chapter" ? selectedBatches : [],
//           subject_ids: searchColumn === "chapter" ? selectedSubjects : [],
//           assessment_ids: [],
//           chapter_ids: [],
//         };

//         const response = await axios.post(
//           `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=${value.course_id}${
//             searchKey ? `&search_key=${searchKey}` : ""
//           }${searchColumn ? `&search_column=${searchColumn}` : ""}`,
//           body,
//           {
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const data = response.data || []; // Ensure data is an array
//         setApiData(data || []); // Ensure apiData is always an array

//         if (searchColumn === "") {
//           // If not filtering for chapters, set batch and subject data
//           const uniqueBatches = [];
//           const uniqueSubjects = [];

//           data.forEach((item) => {
//             if (!uniqueBatches.find((batch) => batch.id === item.batch_id)) {
//               uniqueBatches.push({ label: item.batch_name, id: item.batch_id });
//             }
//             if (!uniqueSubjects.find((subject) => subject.id === item.subject_id)) {
//               uniqueSubjects.push({
//                 label: item.subject_name,
//                 id: item.subject_id,
//               });
//             }
//           });

//           setBatchData(uniqueBatches);
//           setFilteredBatches(uniqueBatches); // Initially show all batches
//           setSubjectData(uniqueSubjects);
//           setFilteredSubjects(uniqueSubjects); // Initially show all subjects
//         } else if (searchColumn === "chapter") {
//           // Handle chapters
//           const mergedChapters = mergeChapterOptions(data || []); // Ensure data is an array
//           setChapterOptions(mergedChapters); // Set chapter options
//         }
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     },
//     [value.course_id, selectedBatches, selectedSubjects]
//   );

//   // Fetch chapters based on search term
//   const fetchChapterOptions = async (searchTerm) => {
//     if (!searchTerm || searchTerm.length < 3) {
//       console.log("Search term must be at least 3 characters");
//       return []; // Do not fetch if search term is less than 3 characters
//     }

//     try {
//       console.log("Fetching chapters with search term:", searchTerm);
//       await fetchData(searchTerm, "chapter");
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//     }
//   };

//   // Function to merge chapters with the same chapter ID
//   const mergeChapterOptions = (data) => {
//     const chapterMap = new Map();

//     data.forEach((item) => {
//       if (!chapterMap.has(item.chapter_id)) {
//         chapterMap.set(item.chapter_id, {
//           id: item.chapter_id,
//           Option1: item.chapter_name,
//           Option2: item.batch_name,
//           Option3: item.subject_name,
//           Headers1: "Chapter Name",
//           Headers2: "Batch Name",
//           Headers3: "Subject Name",
//         });
//       }
//     });

//     return Array.from(chapterMap.values());
//   };

//   const handleSelectedChapters = (selectedIds) => {
//     if (!selectedIds) return; // Add a check to avoid undefined or null
//     console.log("Selected chapter IDs:", selectedIds);
//     setSelectedChapters(selectedIds);
//   };

//   // Fetch data for batches and subjects when the component is mounted or when course_id changes
//   useEffect(() => {
//     if (value.course_id) {
//       fetchData(); // Fetch batches and subjects when course_id is selected
//     }
//   }, [value.course_id, fetchData]);

//   return (
//     <div style={{ padding: "20px" }}>
//       <div>
//         {/* Course dropdown */}
//         <DropDownMultipleSelection
//           label="Course"
//           width="13.5vw"
//           selected={value.course_id}
//           setSelected={(selectedOption) =>
//             setValues({ ...value, course_id: selectedOption })
//           }
//           options={[
//             { label: "NEET", id: 1 },
//             { label: "JEE", id: 2 },
//             // Add more courses as needed
//           ]}
//         />
//       </div>

//       {/* Batch Dropdown */}
//       <DropDownMultipleSelection
//         label="Batch"
//         width="13.5vw"
//         selected={selectedBatches}
//         setSelected={setSelectedBatches}
//         options={filteredBatches} // Filtered batch data
//         showSelectAll={true}
//       />

//       {/* Subject Dropdown */}
//       <DropDownMultipleSelection
//         label="Subject"
//         width="13.5vw"
//         selected={selectedSubjects}
//         setSelected={setSelectedSubjects}
//         options={filteredSubjects} // Filtered subject data
//         showSelectAll={true}
//       />

//       {/* Chapter Dropdown */}
//       <DropDownMultipleSearchSelection
//         width="13.5vw"
//         customWidth="25vw"
//         label="Select Chapters"
//         selected={selectedChapters}
//         setSelected={handleSelectedChapters}
//         fetchOptions={fetchChapterOptions} // Use the fetchChapterOptions for search
//         showSelectAll={true}
//         optionsData={chapterOptions} // Pass chapterOptions as data
//       />
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useEffect, useCallback } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import Swal from "sweetalert2";
// import axios from "axios";

// // Assuming InterogativeImg is an image or icon, import or define it here
// import InterogativeImg from "../../Assets/Images/CommanImages/Interogative.png"; // <-- Update the correct path

// const POP = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const [subjectData, setSubjectData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);

//   // Initialize the missing selectedChapters state
//   const [selectedChapters, setSelectedChapters] = useState([]); // Add this state to fix the undefined error

//   const [chapterOptions, setChapterOptions] = useState([]); // Initialize with an empty array
//   const [value, setValues] = useState({
//     course_id: "", // course_id will be selected from dropdown
//   });

//   // Fetch chapters based on search term and subject
//   const fetchChaptersBySubject = async (searchKey) => {
//     if (!searchKey || !value.course_id) {
//       return Promise.resolve([]); // Return empty if no course ID or searchKey
//     }

//     try {
//       let url = `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=${value.course_id}&search_key=${searchKey}&search_column=chapter`;

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           batch_ids: selectedBatches.length > 0 ? selectedBatches : [],
//           subject_ids: selectedSubjects.length > 0 ? selectedSubjects : [],
//           assessment_ids: [],
//           chapter_ids: [],
//         }),
//       });

//       const data = await response.json();

//       // Format and set chapters, subjects, and batches
//       const formattedChapters = [];
//       const formattedSubjects = [];
//       const formattedBatches = [];

//       data.forEach((item) => {
//         // Filter unique chapters
//         if (
//           !formattedChapters.find((chapter) => chapter.id === item.chapter_id)
//         ) {
//           formattedChapters.push({
//             label: item.chapter_name,
//             id: item.chapter_id,
//             Option1: item.chapter_name,
//             Option2: item.subject_name,
//             Option3: item.course_name,
//             Headers1: "Chapter Name",
//             Headers2: "Subject Name",
//             Headers3: "Course Name",
//           });
//         }

//         // Filter unique subjects
//         if (
//           !formattedSubjects.find((subject) => subject.id === item.subject_id)
//         ) {
//           formattedSubjects.push({
//             label: item.subject_name,
//             id: item.subject_id,
//           });
//         }

//         // Filter unique batches
//         if (!formattedBatches.find((batch) => batch.id === item.batch_id)) {
//           formattedBatches.push({
//             label: item.batch_name,
//             id: item.batch_id,
//           });
//         }
//       });

//       setChapterOptions(formattedChapters); // Set the chapter data
//       setFilteredSubjects(formattedSubjects); // Set the subject data
//       setFilteredBatches(formattedBatches); // Set the batch data

//       return formattedChapters;
//     } catch (error) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer}
//           onMouseLeave={resumeTimer}
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg); // Use the imported InterogativeImg
//       return [];
//     }
//   };

//   const handleSelectedChapters = (selectedIds) => {
//     if (!selectedIds?.length) return; // Add a check to avoid undefined or null
//     console.log("Selected chapter IDs:", selectedIds);
//     setSelectedChapters(selectedIds);
//   };

//   // Fetch data for batches and subjects when the component is mounted or when course_id changes
//   useEffect(() => {
//     if (value.course_id) {
//       fetchChaptersBySubject(""); // Fetch batches and subjects when course_id is selected
//     }
//   }, [value.course_id, fetchChaptersBySubject]);

//   return (
//     <div style={{ padding: "20px" }}>
//       <div>
//         {/* Course dropdown */}
//         <DropDownMultipleSelection
//           label="Course"
//           width="13.5vw"
//           selected={value.course_id}
//           setSelected={(selectedOption) =>
//             setValues({ ...value, course_id: selectedOption })
//           }
//           options={[
//             { label: "NEET", id: 1 },
//             { label: "JEE", id: 2 },
//             // Add more courses as needed
//           ]}
//         />
//       </div>

//       {/* Batch Dropdown */}
//       <DropDownMultipleSelection
//         label="Batch"
//         width="13.5vw"
//         selected={selectedBatches}
//         setSelected={setSelectedBatches}
//         options={filteredBatches} // Filtered batch data
//         showSelectAll={true}
//       />

//       {/* Subject Dropdown */}
//       <DropDownMultipleSelection
//         label="Subject"
//         width="13.5vw"
//         selected={selectedSubjects}
//         setSelected={setSelectedSubjects}
//         options={filteredSubjects} // Filtered subject data
//         showSelectAll={true}
//       />

//       {/* Chapter Dropdown */}
//       <DropDownMultipleSearchSelection
//         width="13.5vw"
//         customWidth="25vw"
//         label="Select Chapters"
//         selected={selectedChapters} // Use the selectedChapters state
//         setSelected={handleSelectedChapters} // Set the selected chapters
//         fetchOptions={fetchChaptersBySubject} // Use the fetchChapterOptions for search
//         showSelectAll={true}
//         optionsData={chapterOptions} // Pass chapterOptions as data
//       />
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useEffect, useCallback } from "react";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import Swal from "sweetalert2";
// import axios from "axios";

// // Assuming InterogativeImg is an image or icon, import or define it here
// // import InterogativeImg from "../../path/to/interogative-image"; // <-- Update the correct path

// const POP = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const [subjectData, setSubjectData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedChapters, setSelectedChapters] = useState([]); // Add this state to fix the undefined error
//   const [chapterOptions, setChapterOptions] = useState([]); // Initialize with an empty array
//   const [isChapterSearch, setIsChapterSearch] = useState(false);
//   const [loadingChapters, setLoadingChapters] = useState(false); // Add loading state for chapters
//   const [value, setValues] = useState({
//     course_id: "", // course_id will be selected from dropdown
//   });

//   // Fetch data with searchKey and searchColumn conditionally based on isChapterSearch
//   const fetchData = useCallback(
//     async (searchKey = "", searchColumn = "") => {
//       if (!value.course_id) return; // Only run if course_id is selected

//       try {
//         const body = {
//           batch_ids: selectedBatches.length > 0 ? selectedBatches : [],
//           subject_ids: selectedSubjects.length > 0 ? selectedSubjects : [],
//           assessment_ids: [],
//           chapter_ids: [],
//         };

//         // Build the API URL conditionally based on the isChapterSearch boolean flag
//         let apiUrl = `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey/?course_id=${value.course_id}`;
//         if (isChapterSearch && searchKey) {
//           apiUrl += `&search_key=${searchKey}&search_column=${searchColumn}`;
//         }

//         const response = await axios.post(apiUrl, body, {
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         });

//         const data = response?.data || []; // Ensure data is an array using optional chaining
//         if (!isChapterSearch) {
//           const uniqueBatches = [];
//           const uniqueSubjects = [];

//           data.forEach((item) => {
//             if (!uniqueBatches.find((batch) => batch.id === item.batch_id)) {
//               uniqueBatches.push({ label: item.batch_name, id: item.batch_id });
//             }
//             if (!uniqueSubjects.find((subject) => subject.id === item.subject_id)) {
//               uniqueSubjects.push({
//                 label: item.subject_name,
//                 id: item.subject_id,
//               });
//             }
//           });

//           setBatchData(uniqueBatches);
//           setFilteredBatches(uniqueBatches);
//           setSubjectData(uniqueSubjects);
//           setFilteredSubjects(uniqueSubjects);
//         } else {
//           // Handle chapters when searchKey and searchColumn are applied
//           const mergedChapters = mergeChapterOptions(data || []); // Ensure data is an array
//           setChapterOptions(mergedChapters); // Set chapter options
//         }
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       } finally {
//         setLoadingChapters(false); // Ensure loading state is reset
//       }
//     },
//     [value.course_id, selectedBatches, selectedSubjects, isChapterSearch]
//   );

//   // Fetch chapters based on search term
//   const fetchChapterOptions = async (searchTerm) => {
//     if (!searchTerm || searchTerm.length < 3) {
//       console.log("Search term must be at least 3 characters");
//       return []; // Do not fetch if search term is less than 3 characters
//     }

//     try {
//       setLoadingChapters(true); // Set loading state
//       setIsChapterSearch(true); // Set the flag to indicate chapter search
//       console.log("Fetching chapters with search term:", searchTerm);
//       await fetchData(searchTerm, "chapter");
//     } catch (error) {
//       console.error("Error fetching chapters:", error);
//     }
//   };

//   // Function to merge chapters with the same chapter ID
//   const mergeChapterOptions = (data) => {
//     const chapterMap = new Map();

//     data.forEach((item) => {
//       if (!chapterMap.has(item.chapter_id)) {
//         chapterMap.set(item.chapter_id, {
//           id: item.chapter_id,
//           Option1: item.chapter_name,
//           Option2: item.subject_name,
//           Option3: item.course_name,
//           Headers1: "Chapter Name",
//           Headers2: "Subject Name",
//           Headers3: "Course Name",
//         });
//       }
//     });

//     return Array.from(chapterMap.values());
//   };

//   const handleSelectedChapters = (selectedIds) => {
//     if (!selectedIds?.length) return; // Add a check to avoid undefined or null
//     console.log("Selected chapter IDs:", selectedIds);
//     setSelectedChapters(selectedIds);
//   };

//   // Fetch data for batches and subjects when the component is mounted or when course_id changes
//   useEffect(() => {
//     if (value.course_id) {
//       setIsChapterSearch(false); // Reset the flag for non-chapter searches
//       fetchData(); // Fetch batches and subjects when course_id is selected
//     }
//   }, [value.course_id, fetchData]);

//   return (
//     <div style={{ padding: "20px" }}>
//       <div>
//         {/* Course dropdown */}
//         <DropDownMultipleSelection
//           label="Course"
//           width="13.5vw"
//           selected={value.course_id}
//           setSelected={(selectedOption) =>
//             setValues({ ...value, course_id: selectedOption })
//           }
//           options={[
//             { label: "NEET", id: 1 },
//             { label: "JEE", id: 2 },
//             // Add more courses as needed
//           ]}
//         />
//       </div>

//       {/* Batch Dropdown */}
//       <DropDownMultipleSelection
//         label="Batch"
//         width="13.5vw"
//         selected={selectedBatches}
//         setSelected={setSelectedBatches}
//         options={filteredBatches || []} // Ensure it is always an array
//         showSelectAll={true}
//       />

//       {/* Subject Dropdown */}
//       <DropDownMultipleSelection
//         label="Subject"
//         width="13.5vw"
//         selected={selectedSubjects}
//         setSelected={setSelectedSubjects}
//         options={filteredSubjects || []} // Ensure it is always an array
//         showSelectAll={true}
//       />

//       {/* Chapter Dropdown */}
//       <DropDownMultipleSearchSelection
//         width="13.5vw"
//         customWidth="25vw"
//         label="Select Chapters"
//         selected={selectedChapters || []} // Ensure it is always an array
//         setSelected={handleSelectedChapters} // Set the selected chapters
//         fetchOptions={fetchChapterOptions} // Use the fetchChapterOptions for search
//         showSelectAll={true}
//         optionsData={chapterOptions || []} // Pass chapterOptions, ensure it is always an array
//         loading={loadingChapters} // Pass loading state to show loading indication
//       />
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useEffect } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";

// const StudentDPPSummary = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);

//   // Function to merge duplicate ids by concatenating their values
//   const mergeDataById = (data, idField, nameField) => {
//     const mergedData = {};

//     data.forEach(item => {
//       const id = item[idField];

//       if (mergedData[id]) {
//         // If the id already exists, concatenate the name fields
//         mergedData[id][nameField] += `, ${item[nameField]}`;
//       } else {
//         // If it's a new id, create a new entry
//         mergedData[id] = {
//           id: item[idField],
//           name: item[nameField],
//         };
//       }
//     });

//     return Object.values(mergedData);
//   };

//   // Function to fetch data for all dropdowns (Batch, Subject, Chapter, DPP)
//   const fetchDropdownData = async (selectedChapters = [], selectedDppIds = []) => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: selectedBatches,
//             subject_ids: selectedSubjects,
//             chapter_ids: selectedChapters,
//             assessment_ids: selectedDppIds,
//             search_key: "",
//             search_column: "",
//           }),
//         }
//       );
//       const data = await response.json();

//       // Merge duplicate entries by id for each dropdown
//       const mergedBatchData = mergeDataById(data, "batch_id", "batch_name");
//       const mergedSubjectData = mergeDataById(data, "subject_id", "subject_name");
//       const mergedChapterData = mergeDataById(data, "chapter_id", "chapter_name");
//       const mergedDppData = mergeDataById(data, "assessment_id", "assessment_name");

//       // Set state for the dropdowns with merged data
//       setBatchData(mergedBatchData);
//       setSubjectData(mergedSubjectData);
//       setChapterData(mergedChapterData);
//       setDppData(mergedDppData);
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//     }
//   };

//   // Fetch initial data for all dropdowns on component mount
//   useEffect(() => {
//     fetchDropdownData();
//   }, []);

//   const handleChapterChange = (e) => {
//     const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
//     setSelectedChapters(selectedValues);
//     fetchDropdownData(selectedValues, selectedDppIds); // Fetch new data based on selected chapters
//   };

//   const handleDppChange = (e) => {
//     const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
//     setSelectedDppIds(selectedValues);
//     fetchDropdownData(selectedChapters, selectedValues); // Fetch new data based on selected DPPs
//   };

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Chapter Dropdown */}
//         <label htmlFor="chapterSelect">Select Chapter</label>
//         <select
//           id="chapterSelect"
//           multiple={true}
//           value={selectedChapters}
//           onChange={handleChapterChange}
//         >
//           {chapterData.map(chapter => (
//             <option key={chapter.id} value={chapter.id}>
//               {chapter.name}
//             </option>
//           ))}
//         </select>

//         {/* Batch Dropdown */}
//         <label htmlFor="batchSelect">Select Batch</label>
//         <select
//           id="batchSelect"
//           multiple={true}
//           value={selectedBatches}
//           onChange={e => setSelectedBatches(Array.from(e.target.selectedOptions, option => option.value))}
//         >
//           {batchData.map(batch => (
//             <option key={batch.id} value={batch.id}>
//               {batch.name}
//             </option>
//           ))}
//         </select>

//         {/* Subject Dropdown */}
//         <label htmlFor="subjectSelect">Select Subject</label>
//         <select
//           id="subjectSelect"
//           multiple={true}
//           value={selectedSubjects}
//           onChange={e => setSelectedSubjects(Array.from(e.target.selectedOptions, option => option.value))}
//         >
//           {subjectData.map(subject => (
//             <option key={subject.id} value={subject.id}>
//               {subject.name}
//             </option>
//           ))}
//         </select>

//         {/* DPP Dropdown */}
//         <label htmlFor="dppSelect">Select DPP</label>
//         <select
//           id="dppSelect"
//           multiple={true}
//           value={selectedDppIds}
//           onChange={handleDppChange}
//         >
//           {dppData.map(dpp => (
//             <option key={dpp.id} value={dpp.id}>
//               {dpp.name}
//             </option>
//           ))}
//         </select>
//       </div>

//       {/* Table component */}
//       {/* Add your TableComponent below */}
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";

// const StudentDPPSummary = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);

//   // Function to merge duplicate ids by concatenating their values
//   const mergeDataById = (data, idField, nameField) => {
//     const mergedData = {};

//     data.forEach((item) => {
//       const id = item[idField];

//       if (mergedData[id]) {
//         // If the id already exists, concatenate the name fields
//         mergedData[id][nameField] += `, ${item[nameField]}`;
//       } else {
//         // If it's a new id, create a new entry
//         mergedData[id] = {
//           id: item[idField],
//           name: item[nameField],
//         };
//       }
//     });

//     return Object.values(mergedData);
//   };

//   // Function to fetch data for all dropdowns (Batch, Subject, Chapter, DPP)
//   const fetchDropdownData = async (selectedChapters = [], selectedDppIds = []) => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: selectedBatches,
//             subject_ids: selectedSubjects,
//             chapter_ids: selectedChapters,
//             assessment_ids: selectedDppIds,
//             search_key: "",
//             search_column: "",
//           }),
//         }
//       );
//       const data = await response.json();

//       // Merge duplicate entries by id for each dropdown
//       const mergedBatchData = mergeDataById(data, "batch_id", "batch_name");
//       const mergedSubjectData = mergeDataById(data, "subject_id", "subject_name");
//       const mergedChapterData = mergeDataById(data, "chapter_id", "chapter_name");
//       const mergedDppData = mergeDataById(data, "assessment_id", "assessment_name");

//       // Set state for the dropdowns with merged data
//       setBatchData(mergedBatchData);
//       setSubjectData(mergedSubjectData);
//       setChapterData(mergedChapterData);
//       setDppData(mergedDppData);
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//     }
//   };

//   // Fetch initial data for all dropdowns on component mount
//   useEffect(() => {
//     fetchDropdownData();
//   }, []);

//   // Handle checkbox selection for each dropdown
//   const handleCheckboxChange = (e, setState, selectedState) => {
//     const value = e.target.value;
//     const isChecked = e.target.checked;

//     if (isChecked) {
//       setState([...selectedState, value]);
//     } else {
//       setState(selectedState.filter((item) => item !== value));
//     }
//   };

//   // Trigger data refresh when the user clicks "Apply"
//   const handleApply = () => {
//     fetchDropdownData(selectedChapters, selectedDppIds);
//   };

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Chapter Dropdown */}
//         <label htmlFor="chapterSelect">Select Chapter</label>
//         <div id="chapterSelect">
//           {chapterData.map((chapter) => (
//             <div key={chapter.id}>
//               <input
//                 type="checkbox"
//                 value={chapter.id}
//                 checked={selectedChapters.includes(chapter.id)}
//                 onChange={(e) => handleCheckboxChange(e, setSelectedChapters, selectedChapters)}
//               />
//               {chapter.name}
//             </div>
//           ))}
//         </div>

//         {/* Batch Dropdown */}
//         <label htmlFor="batchSelect">Select Batch</label>
//         <div id="batchSelect">
//           {batchData.map((batch) => (
//             <div key={batch.id}>
//               <input
//                 type="checkbox"
//                 value={batch.id}
//                 checked={selectedBatches.includes(batch.id)}
//                 onChange={(e) => handleCheckboxChange(e, setSelectedBatches, selectedBatches)}
//               />
//               {batch.name}
//             </div>
//           ))}
//         </div>

//         {/* Subject Dropdown */}
//         <label htmlFor="subjectSelect">Select Subject</label>
//         <div id="subjectSelect">
//           {subjectData.map((subject) => (
//             <div key={subject.id}>
//               <input
//                 type="checkbox"
//                 value={subject.id}
//                 checked={selectedSubjects.includes(subject.id)}
//                 onChange={(e) => handleCheckboxChange(e, setSelectedSubjects, selectedSubjects)}
//               />
//               {subject.name}
//             </div>
//           ))}
//         </div>

//         {/* DPP Dropdown */}
//         <label htmlFor="dppSelect">Select DPP</label>
//         <div id="dppSelect">
//           {dppData.map((dpp) => (
//             <div key={dpp.id}>
//               <input
//                 type="checkbox"
//                 value={dpp.id}
//                 checked={selectedDppIds.includes(dpp.id)}
//                 onChange={(e) => handleCheckboxChange(e, setSelectedDppIds, selectedDppIds)}
//               />
//               {dpp.name}
//             </div>
//           ))}
//         </div>

//         {/* Apply Button */}
//         <button onClick={handleApply}>Apply</button>
//       </div>

//       {/* Table component */}
//       {/* Add your TableComponent below */}
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";

// const StudentDPPSummary = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);

//   const [chapterSearchKey, setChapterSearchKey] = useState('');
//   const [dppSearchKey, setDppSearchKey] = useState('');

//   // Function to merge duplicate ids by concatenating their values
//   const mergeDataById = (data, idField, nameField) => {
//     const mergedData = {};

//     data.forEach((item) => {
//       const id = item[idField];

//       if (mergedData[id]) {
//         // If the id already exists, concatenate the name fields
//         mergedData[id][nameField] += `, ${item[nameField]}`;
//       } else {
//         // If it's a new id, create a new entry
//         mergedData[id] = {
//           id: item[idField],
//           name: item[nameField],
//         };
//       }
//     });

//     return Object.values(mergedData);
//   };

//   // Function to fetch data for all dropdowns (Batch, Subject, Chapter, DPP)
//   const fetchDropdownData = async (searchKey = "", searchColumn = "", selectedChapters = [], selectedDppIds = []) => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: selectedBatches,
//             subject_ids: selectedSubjects,
//             chapter_ids: selectedChapters,
//             assessment_ids: selectedDppIds,
//             search_key: searchKey,
//             search_column: searchColumn,
//           }),
//         }
//       );
//       const data = await response.json();

//       // Merge duplicate entries by id for each dropdown
//       const mergedBatchData = mergeDataById(data, "batch_id", "batch_name");
//       const mergedSubjectData = mergeDataById(data, "subject_id", "subject_name");
//       const mergedChapterData = mergeDataById(data, "chapter_id", "chapter_name");
//       const mergedDppData = mergeDataById(data, "assessment_id", "assessment_name");

//       // Set state for the dropdowns with merged data
//       setBatchData(mergedBatchData);
//       setSubjectData(mergedSubjectData);
//       setChapterData(mergedChapterData);
//       setDppData(mergedDppData);
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//     }
//   };

//   // Fetch initial data for all dropdowns on component mount
//   useEffect(() => {
//     fetchDropdownData();
//   }, []);

//   // Handle checkbox selection for each dropdown
//   const handleCheckboxChange = (e, setState, selectedState) => {
//     const value = e.target.value;
//     const isChecked = e.target.checked;

//     if (isChecked) {
//       setState([...selectedState, value]);
//     } else {
//       setState(selectedState.filter((item) => item !== value));
//     }
//   };

//   // Handle search for Chapter
//   const handleChapterSearch = () => {
//     fetchDropdownData(chapterSearchKey, 'chapter', selectedChapters, selectedDppIds);
//   };

//   // Handle search for DPP
//   const handleDppSearch = () => {
//     fetchDropdownData(dppSearchKey, 'dpp', selectedChapters, selectedDppIds);
//   };

//   // Trigger data refresh when the user clicks "Apply"
//   const handleApply = () => {
//     fetchDropdownData("", "", selectedChapters, selectedDppIds); // No search column or key for general apply
//   };

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Chapter Dropdown with Search */}
//         <label htmlFor="chapterSelect">Search Chapter</label>
//         <input
//           type="text"
//           value={chapterSearchKey}
//           onChange={(e) => setChapterSearchKey(e.target.value)}
//           placeholder="Search Chapter"
//         />
//         <button onClick={handleChapterSearch}>Search</button>
//         <div id="chapterSelect">
//           {chapterData.map((chapter) => (
//             <div key={chapter.id}>
//               <input
//                 type="checkbox"
//                 value={chapter.id}
//                 checked={selectedChapters.includes(chapter.id)}
//                 onChange={(e) => handleCheckboxChange(e, setSelectedChapters, selectedChapters)}
//               />
//               {chapter.name}
//             </div>
//           ))}
//         </div>

//         {/* DPP Dropdown with Search */}
//         <label htmlFor="dppSelect">Search DPP</label>
//         <input
//           type="text"
//           value={dppSearchKey}
//           onChange={(e) => setDppSearchKey(e.target.value)}
//           placeholder="Search DPP"
//         />
//         <button onClick={handleDppSearch}>Search</button>
//         <div id="dppSelect">
//           {dppData.map((dpp) => (
//             <div key={dpp.id}>
//               <input
//                 type="checkbox"
//                 value={dpp.id}
//                 checked={selectedDppIds.includes(dpp.id)}
//                 onChange={(e) => handleCheckboxChange(e, setSelectedDppIds, selectedDppIds)}
//               />
//               {dpp.name}
//             </div>
//           ))}
//         </div>

//         {/* Batch Dropdown */}
//         <label htmlFor="batchSelect">Select Batch</label>
//         <div id="batchSelect">
//           {batchData.map((batch) => (
//             <div key={batch.id}>
//               <input
//                 type="checkbox"
//                 value={batch.id}
//                 checked={selectedBatches.includes(batch.id)}
//                 onChange={(e) => handleCheckboxChange(e, setSelectedBatches, selectedBatches)}
//               />
//               {batch.name}
//             </div>
//           ))}
//         </div>

//         {/* Subject Dropdown */}
//         <label htmlFor="subjectSelect">Select Subject</label>
//         <div id="subjectSelect">
//           {subjectData.map((subject) => (
//             <div key={subject.id}>
//               <input
//                 type="checkbox"
//                 value={subject.id}
//                 checked={selectedSubjects.includes(subject.id)}
//                 onChange={(e) => handleCheckboxChange(e, setSelectedSubjects, selectedSubjects)}
//               />
//               {subject.name}
//             </div>
//           ))}
//         </div>

//         {/* Apply Button */}
//         <button onClick={handleApply}>Apply</button>
//       </div>

//       {/* Table component */}
//       {/* Add your TableComponent below */}
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect ,useCallback} from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent"; // Import your dropdown component
// import _ from "lodash"; // Import lodash for debounce

// // import React, { useState, useEffect, useCallback } from "react";
// // import { FULL_API_BASE_URL } from "../../Config/Config";
// // import DropDownMultipleSelection from "./DropDownMultipleSelection";
// // import _ from "lodash"; // Import lodash for debounce

// // Function to merge duplicate ids by concatenating their values
// const mergeDataById = (data, idField, nameField) => {
//   const mergedData = {};

//   data.forEach((item) => {
//     const id = item[idField];

//     if (mergedData[id]) {
//       mergedData[id][nameField] += `, ${item[nameField]}`;
//     } else {
//       mergedData[id] = {
//         id: item[idField],
//         name: item[nameField],
//       };
//     }
//   });

//   return Object.values(mergedData);
// };

// const StudentDPPSummary = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);

//   const [chapterSearchKey, setChapterSearchKey] = useState("");
//   const [dppSearchKey, setDppSearchKey] = useState("");

//   // Debounce function inside useEffect for API call
//   const fetchDropdownData = useCallback(
//     _.debounce(async (searchKey = "", searchColumn = "", selectedChapters = [], selectedDppIds = []) => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               batch_ids: selectedBatches,
//               subject_ids: selectedSubjects,
//               chapter_ids: selectedChapters,
//               assessment_ids: selectedDppIds,
//               search_key: searchKey,
//               search_column: searchColumn,
//             }),
//           }
//         );
//         const data = await response.json();

//         const mergedBatchData = mergeDataById(data, "batch_id", "batch_name");
//         const mergedSubjectData = mergeDataById(data, "subject_id", "subject_name");
//         const mergedChapterData = mergeDataById(data, "chapter_id", "chapter_name");
//         const mergedDppData = mergeDataById(data, "assessment_id", "assessment_name");

//         setBatchData(mergedBatchData);
//         setSubjectData(mergedSubjectData);
//         setChapterData(mergedChapterData);
//         setDppData(mergedDppData);
//       } catch (error) {
//         console.error("Error fetching dropdown data:", error);
//       }
//     }, 1000),
//     [selectedBatches, selectedSubjects, selectedChapters, selectedDppIds]
//   );

//   // Trigger debounce API call when any of the selected options change
//   useEffect(() => {
//     fetchDropdownData("", "", selectedChapters, selectedDppIds); // No search key or column for general fetch
//   }, [selectedBatches, selectedSubjects, selectedChapters, selectedDppIds, fetchDropdownData]);

//   // Handle selection changes
//   const handleSelectionChange = (type, selectedValues) => {
//     if (type === "batch") {
//       setSelectedBatches(selectedValues);
//     } else if (type === "subject") {
//       setSelectedSubjects(selectedValues);
//     } else if (type === "chapter") {
//       setSelectedChapters(selectedValues);
//     } else if (type === "dpp") {
//       setSelectedDppIds(selectedValues);
//     }
//   };

//   // Handle search for Chapter
//   const handleChapterSearch = (value) => {
//     setChapterSearchKey(value);
//     fetchDropdownData(value, "chapter", selectedChapters, selectedDppIds);
//   };

//   // Handle search for DPP
//   const handleDppSearch = (value) => {
//     setDppSearchKey(value);
//     fetchDropdownData(value, "dpp", selectedChapters, selectedDppIds);
//   };

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Chapter Dropdown with Search */}
//         <label htmlFor="chapterSelect">Search Chapter</label>
//         <input
//           type="text"
//           value={chapterSearchKey}
//           onChange={(e) => handleChapterSearch(e.target.value)}
//           placeholder="Search Chapter"
//         />
//         <div id="chapterSelect">
//           {chapterData.map((chapter) => (
//             <div key={chapter.id}>
//               <input
//                 type="checkbox"
//                 value={chapter.id}
//                 checked={selectedChapters.includes(chapter.id)}
//                 onChange={(e) =>
//                   handleSelectionChange(
//                     "chapter",
//                     e.target.checked
//                       ? [...selectedChapters, chapter.id]
//                       : selectedChapters.filter((id) => id !== chapter.id)
//                   )
//                 }
//               />
//               {chapter.name}
//             </div>
//           ))}
//         </div>

//         {/* DPP Dropdown with Search */}
//         <label htmlFor="dppSelect">Search DPP</label>
//         <input
//           type="text"
//           value={dppSearchKey}
//           onChange={(e) => handleDppSearch(e.target.value)}
//           placeholder="Search DPP"
//         />
//         <div id="dppSelect">
//           {dppData.map((dpp) => (
//             <div key={dpp.id}>
//               <input
//                 type="checkbox"
//                 value={dpp.id}
//                 checked={selectedDppIds.includes(dpp.id)}
//                 onChange={(e) =>
//                   handleSelectionChange(
//                     "dpp",
//                     e.target.checked
//                       ? [...selectedDppIds, dpp.id]
//                       : selectedDppIds.filter((id) => id !== dpp.id)
//                   )
//                 }
//               />
//               {dpp.name}
//             </div>
//           ))}
//         </div>

//         {/* Batch Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Batch"
//           selected={selectedBatches}
//           setSelected={(selected) => handleSelectionChange("batch", selected)}
//           options={batchData.map((batch) => ({
//             id: batch.id,
//             label: batch.name,
//           }))}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Subject Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Subject"
//           selected={selectedSubjects}
//           setSelected={(selected) => handleSelectionChange("subject", selected)}
//           options={subjectData.map((subject) => ({
//             id: subject.id,
//             label: subject.name,
//           }))}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />
//       </div>
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect, useCallback } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent"; // Import your dropdown component
// import DropDownMultipleSearchSelection from "../Reports/components/FieldsSearchComponent"; // Import search multi-select component
// import _ from "lodash"; // Import lodash for debounce

// import React, { useState, useEffect, useCallback } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import CustomSearchDropdown from "./FileComp"; // Updated CustomSearchDropdown with checkboxes
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent"; // Multi-select dropdown for batch and subject
// import _ from "lodash"; // Import lodash for debounce

// // Function to merge duplicate ids by concatenating their values
// const mergeDataById = (data, idField, nameField) => {
//   const mergedData = {};

//   data.forEach((item) => {
//     const id = item[idField];

//     if (mergedData[id]) {
//       mergedData[id][nameField] += `, ${item[nameField]}`;
//     } else {
//       mergedData[id] = {
//         id: item[idField],
//         name: item[nameField],
//       };
//     }
//   });

//   return Object.values(mergedData);
// };

// const StudentDPPSummary = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);

//   // Fetch dropdown data from API
//   const fetchDropdownData = useCallback(
//     _.debounce(async (searchKey = "", searchColumn = "", selectedChapters = [], selectedDppIds = []) => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               batch_ids: selectedBatches,
//               subject_ids: selectedSubjects,
//               chapter_ids: selectedChapters,
//               assessment_ids: selectedDppIds,
//               search_key: searchKey,
//               search_column: searchColumn,
//             }),
//           }
//         );
//         const data = await response.json();

//         const mergedBatchData = mergeDataById(data, "batch_id", "batch_name");
//         const mergedSubjectData = mergeDataById(data, "subject_id", "subject_name");
//         const mergedChapterData = mergeDataById(data, "chapter_id", "chapter_name");
//         const mergedDppData = mergeDataById(data, "assessment_id", "assessment_name");

//         setBatchData(mergedBatchData);
//         setSubjectData(mergedSubjectData);
//         setChapterData(mergedChapterData);
//         setDppData(mergedDppData);
//       } catch (error) {
//         console.error("Error fetching dropdown data:", error);
//       }
//     }, 3000),
//     [selectedBatches, selectedSubjects, selectedChapters, selectedDppIds]
//   );

//   // Trigger the API call when any selected options change
//   useEffect(() => {
//     fetchDropdownData("", "", selectedChapters, selectedDppIds);
//   }, [selectedBatches, selectedSubjects, selectedChapters, selectedDppIds, fetchDropdownData]);

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Chapter Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select Chapter"
//           optionsData={chapterData}
//           selected={selectedChapters}
//           setSelected={setSelectedChapters}
//           placeholder="Search for Chapters..."
//           isRequired={true}
//         />

//         {/* DPP Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select DPP"
//           optionsData={dppData}
//           selected={selectedDppIds}
//           setSelected={setSelectedDppIds}
//           placeholder="Search for DPPs..."
//           isRequired={true}
//         />

//         {/* Batch Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Batch"
//           selected={selectedBatches}
//           setSelected={setSelectedBatches}
//           options={batchData.map((batch) => ({
//             id: batch.id,
//             label: batch.name,
//           }))}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Subject Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Subject"
//           selected={selectedSubjects}
//           setSelected={setSelectedSubjects}
//           options={subjectData.map((subject) => ({
//             id: subject.id,
//             label: subject.name,
//           }))}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />
//       </div>
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect, useCallback } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import CustomSearchDropdown from "./FileComp"; // Updated CustomSearchDropdown with checkboxes
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent"; // Multi-select dropdown for batch and subject
// import _ from "lodash"; // Import lodash for debounce

// // Function to merge duplicate ids by concatenating their values
// const mergeDataById = (data, idField, nameField) => {
//   const mergedData = {};

//   data.forEach((item) => {
//     const id = item[idField];

//     if (mergedData[id]) {
//       mergedData[id][nameField] += `, ${item[nameField]}`;
//     } else {
//       mergedData[id] = {
//         id: item[idField],
//         name: item[nameField],
//       };
//     }
//   });

//   return Object.values(mergedData);
// };

// const StudentDPPSummary = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]); // New state for student dropdown

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students

//   // Fetch dropdown data from API
//   const fetchDropdownData = useCallback(
//     _.debounce(async (searchKey = "", searchColumn = "", selectedChapters = [], selectedDppIds = [], selectedStudents = []) => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               batch_ids: selectedBatches,
//               subject_ids: selectedSubjects,
//               chapter_ids: selectedChapters,
//               assessment_ids: selectedDppIds,
//               student_ids: selectedStudents, // Include selected student IDs
//               search_key: searchKey,
//               search_column: searchColumn,
//             }),
//           }
//         );
//         const data = await response.json();

//         const mergedBatchData = mergeDataById(data, "batch_id", "batch_name");
//         const mergedSubjectData = mergeDataById(data, "subject_id", "subject_name");
//         const mergedChapterData = mergeDataById(data, "chapter_id", "chapter_name");
//         const mergedDppData = mergeDataById(data, "assessment_id", "assessment_name");
//         const mergedStudentData = mergeDataById(data, "student_id", "student_name"); // Merge student data

//         setBatchData(mergedBatchData);
//         setSubjectData(mergedSubjectData);
//         setChapterData(mergedChapterData);
//         setDppData(mergedDppData);
//         setStudentData(mergedStudentData); // Set student data in state
//       } catch (error) {
//         console.error("Error fetching dropdown data:", error);
//       }
//     }, 3000),
//     [selectedBatches, selectedSubjects, selectedChapters, selectedDppIds, selectedStudents]
//   );

//   // Trigger the API call when any selected options change
//   useEffect(() => {
//     fetchDropdownData("", "", selectedChapters, selectedDppIds, selectedStudents);
//   }, [selectedBatches, selectedSubjects, selectedChapters, selectedDppIds, selectedStudents, fetchDropdownData]);

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Chapter Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select Chapter"
//           optionsData={chapterData}
//           selected={selectedChapters}
//           setSelected={setSelectedChapters}
//           placeholder="Search for Chapters..."
//           isRequired={true}
//         />

//         {/* DPP Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select DPP"
//           optionsData={dppData}
//           selected={selectedDppIds}
//           setSelected={setSelectedDppIds}
//           placeholder="Search for DPPs..."
//           isRequired={true}
//         />

//         {/* Student Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select Student"
//           optionsData={studentData}
//           selected={selectedStudents}
//           setSelected={setSelectedStudents}
//           placeholder="Search for Students..."
//           isRequired={true}
//         />

//         {/* Batch Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Batch"
//           selected={selectedBatches}
//           setSelected={setSelectedBatches}
//           options={batchData.map((batch) => ({
//             id: batch.id,
//             label: batch.name,
//           }))}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Subject Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Subject"
//           selected={selectedSubjects}
//           setSelected={setSelectedSubjects}
//           options={subjectData.map((subject) => ({
//             id: subject.id,
//             label: subject.name,
//           }))}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />
//       </div>
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect, useCallback } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import CustomSearchDropdown from "./FileComp"; // Updated CustomSearchDropdown with checkboxes
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent"; // Multi-select dropdown for batch and subject
// import _ from "lodash"; // Import lodash for debounce

// // Function to map API data to dropdown options format
// const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
//   return dataArray.map((item) => ({
//     id: item[idField],
//     label: item[nameField],
//   }));
// };

// const StudentDPPSummary = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]); // New state for student dropdown

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students

//   // Fetch dropdown data from API
//   const fetchDropdownData = useCallback(
//     _.debounce(
//       async (
//         searchKey = "",
//         searchColumn = "",
//         selectedChapters = [],
//         selectedDppIds = [],
//         selectedStudents = []
//       ) => {
//         try {
//           const response = await fetch(
//             `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//             {
//               method: "POST",
//               headers: {
//                 accept: "application/json",
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 batch_ids: selectedBatches,
//                 subject_ids: selectedSubjects,
//                 chapter_ids: selectedChapters,
//                 assessment_ids: selectedDppIds,
//                 student_ids: selectedStudents, // Include selected student IDs
//                 search_key: searchKey,
//                 search_column: searchColumn,
//               }),
//             }
//           );
//           const data = await response.json();

//           // Mapping the new API data structure
//           setBatchData(
//             mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
//           );
//           setSubjectData(
//             mapDataToDropdownFormat(
//               data.subject_list,
//               "subject_id",
//               "subject_name"
//             )
//           );
//           setChapterData(
//             mapDataToDropdownFormat(
//               data.chapter_list,
//               "chapter_id",
//               "chapter_name"
//             )
//           );
//           setDppData(
//             mapDataToDropdownFormat(
//               data.assessment_list,
//               "assessment_id",
//               "assessment_name"
//             )
//           );
//           setStudentData(
//             mapDataToDropdownFormat(
//               data.student_list,
//               "student_id",
//               "student_name"
//             )
//           );
//         } catch (error) {
//           console.error("Error fetching dropdown data:", error);
//         }
//       },
//       1000
//     ),
//     [
//       selectedBatches,
//       selectedSubjects,
//       selectedChapters,
//       selectedDppIds,
//       selectedStudents,
//     ]
//   );

//   // Trigger the API call when any selected options change
//   useEffect(() => {
//     fetchDropdownData(
//       "",
//       "",
//       selectedChapters,
//       selectedDppIds,
//       selectedStudents
//     );
//   }, [
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     fetchDropdownData,
//   ]);

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Chapter Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select Chapter"
//           optionsData={chapterData}
//           selected={selectedChapters}
//           setSelected={setSelectedChapters}
//           placeholder="Search for Chapters..."
//           isRequired={true}
//           headers={["Chapter Name", "Subject", "Batch"]} // Chapter Dropdown Headers
//         />

//         {/* DPP Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select DPP"
//           optionsData={dppData}
//           selected={selectedDppIds}
//           setSelected={setSelectedDppIds}
//           placeholder="Search for DPPs..."
//           isRequired={true}
//           headers={["DPP Name", "Subject", "Chapter"]} // DPP Dropdown Headers
//         />

//         {/* Student Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select Student"
//           optionsData={studentData} // This is the data for the dropdown
//           selected={selectedStudents}
//           setSelected={setSelectedStudents}
//           placeholder="Search for Students..."
//           isRequired={true}
//           headers={["Student Name", "Roll Number", "Batch"]} // Pass headers dynamically
//           tableData={studentData.map((student) => ({
//             id: student.student_id, // Ensure each row has a unique id
//             option1: student.student_name, // Student Name
//             option2: student.roll_number, // Roll Number
//             option3: student.batch_name, // Batch
//           }))} // Pass student table data
//         />

//         {/* Batch Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Batch"
//           selected={selectedBatches}
//           setSelected={setSelectedBatches}
//           options={batchData}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Subject Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Subject"
//           selected={selectedSubjects}
//           setSelected={setSelectedSubjects}
//           options={subjectData}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />
//       </div>
//     </div>
//   );
// };

// export default StudentDPPSummary;

// import React, { useState, useEffect, useCallback } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import CustomSearchDropdown from "./FileComp4";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import _ from "lodash"; // Import lodash for debounce

// const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
//   return dataArray.map((item) => ({
//     id: item[idField],
//     label: item[nameField],
//   }));
// };

// const POP = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]); // New state for student dropdown

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students

//  const fetchDropdownData = useCallback(
//   _.debounce(
//     async (
//       searchKey = "",
//       searchColumn = "",
//       selectedChapters = [],
//       selectedDppIds = [],
//       selectedStudents = []
//     ) => {
//       try {
//         // Check if the Chapter dropdown has been selected
//         if (selectedChapters.length > 0) {
//           searchKey = ""; // Use the desired search key when chapter is selected
//           searchColumn = "chapter"; // Set searchColumn to 'chapter' when chapter is selected
//         } else {
//           // If other dropdowns like batch or subject are selected, set searchKey and searchColumn to null
//           searchKey = null;
//           searchColumn = null;
//         }

//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               batch_ids: selectedBatches,
//               subject_ids: selectedSubjects,
//               chapter_ids: selectedChapters,
//               assessment_ids: selectedDppIds,
//               student_ids: selectedStudents, // Include selected student IDs
//               search_key: searchKey, // Pass the conditional search key
//               search_column: searchColumn, // Pass the conditional search column
//             }),
//           }
//         );
//         const data = await response.json();

//         // Mapping the new API data structure
//         setBatchData(
//           mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
//         );
//         setSubjectData(
//           mapDataToDropdownFormat(
//             data.subject_list,
//             "subject_id",
//             "subject_name"
//           )
//         );
//         setChapterData(
//           mapDataToDropdownFormat(
//             data.chapter_list,
//             "chapter_id",
//             "chapter_name"
//           )
//         );
//         setDppData(
//           mapDataToDropdownFormat(
//             data.assessment_list,
//             "assessment_id",
//             "assessment_name"
//           )
//         );
//         setStudentData(
//           mapDataToDropdownFormat(
//             data.student_list,
//             "student_id",
//             "student_name"
//           )
//         );
//       } catch (error) {
//         console.error("Error fetching dropdown data:", error);
//       }
//     },
//     // 3000
//   ),
//   [
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//   ]
// );

//   // Trigger the API call when any selected options change
//   useEffect(() => {
//     fetchDropdownData(
//       "",
//       "",
//       selectedChapters,
//       selectedDppIds,
//       selectedStudents
//     );
//   }, [
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     fetchDropdownData,
//   ]);

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Chapter Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select Chapter"
//           optionsData={chapterData}
//           selected={selectedChapters}
//           setSelected={setSelectedChapters}
//           placeholder="Search for Chapters..."
//           isRequired={true}
//         />

//         {/* DPP Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select DPP"
//           optionsData={dppData}
//           selected={selectedDppIds}
//           setSelected={setSelectedDppIds}
//           placeholder="Search for DPPs..."
//           isRequired={true}
//         />

//         {/* Student Dropdown with Custom Search and checkboxes */}
//         <CustomSearchDropdown
//           label="Select Student"
//           optionsData={studentData} // This is the data for the dropdown
//           selected={selectedStudents}
//           setSelected={setSelectedStudents}
//           placeholder="Search for Students..."
//           isRequired={true}
//           tableData={studentData.map((student) => ({
//             id: student.student_id, // Ensure each row has a unique id
//             option1: student.student_name, // Student Name
//             option2: student.roll_number, // Roll Number
//             option3: student.batch_name, // Batch
//           }))} // Pass student table data
//         />

//         {/* Batch Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Batch"
//           selected={selectedBatches}
//           setSelected={setSelectedBatches}
//           options={batchData}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Subject Dropdown using DropDownMultipleSelection */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Subject"
//           selected={selectedSubjects}
//           setSelected={setSelectedSubjects}
//           options={subjectData}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />
//       </div>
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useEffect, useCallback } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import CustomSearchDropdown from "./FileComp4";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import _ from "lodash";

// const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
//   // Remove duplicates from the array
//   return _.uniqBy(
//     dataArray.map((item) => ({
//       id: item[idField],
//       label: item[nameField],
//     })),
//     "id"
//   );
// };

// const POP = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]);

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);

//   const [searchKey, setSearchKey] = useState(null);
//   const [searchColumn, setSearchColumn] = useState(null);

//   const fetchDropdownData = useCallback(
//     _.debounce(async () => {
//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               batch_ids: selectedBatches,
//               subject_ids: selectedSubjects,
//               chapter_ids: selectedChapters,
//               assessment_ids: selectedDppIds,
//               student_ids: selectedStudents,
//               search_key: searchKey, // Pass the current search key
//               search_column: searchColumn, // Pass the current search column
//             }),
//           }
//         );
//         const data = await response.json();

//         setBatchData(
//           mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
//         );
//         setSubjectData(
//           mapDataToDropdownFormat(
//             data.subject_list,
//             "subject_id",
//             "subject_name"
//           )
//         );
//         setChapterData(
//           mapDataToDropdownFormat(
//             data.chapter_list,
//             "chapter_id",
//             "chapter_name"
//           )
//         );
//         setDppData(
//           mapDataToDropdownFormat(
//             data.assessment_list,
//             "assessment_id",
//             "assessment_name"
//           )
//         );
//         setStudentData(
//           mapDataToDropdownFormat(
//             data.student_list,
//             "student_id",
//             "student_name"
//           )
//         );
//       } catch (error) {
//         console.error("Error fetching dropdown data:", error);
//       }
//     }, 500),
//     [
//       selectedBatches,
//       selectedSubjects,
//       selectedChapters,
//       selectedDppIds,
//       selectedStudents,
//       searchKey,
//       searchColumn,
//     ]
//   );

//   useEffect(() => {
//     fetchDropdownData();
//   }, [
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     searchKey,
//     searchColumn,
//     fetchDropdownData,
//   ]);

//   const handleSearchKeyChange = (key, dropdownType) => {
//     // For Chapter, DPP, and Student, check if at least 3 characters are typed
//     if (dropdownType === "chapter" || dropdownType === "dpp" || dropdownType === "student") {
//       if (key.length >= 3) {
//         setSearchKey(key);
//         setSearchColumn(dropdownType); // Use either 'chapter', 'dpp', or 'student'
//       } else {
//         setSearchKey(null); // Before 3 characters, do not search
//         setSearchColumn(null);
//       }
//     } else {
//       // For other dropdowns (Batch, Subject, etc.), set searchKey and searchColumn to null
//       setSearchKey(null);
//       setSearchColumn(null);
//     }
//   };

//   return (
//     <div>
//       <div className="row-cs-uni">
//         {/* Student Dropdown */}
//         <CustomSearchDropdown
//           label="Select Student"
//           optionsData={studentData}
//           selected={selectedStudents}
//           setSelected={setSelectedStudents}
//           placeholder="Search for Students..."
//           isRequired={true}
//           onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")} // Pass key to handleSearchKeyChange
//         />

//         {/* Batch Dropdown */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Batch"
//           selected={selectedBatches}
//           setSelected={setSelectedBatches}
//           options={batchData}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Subject Dropdown */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Subject"
//           selected={selectedSubjects}
//           setSelected={setSelectedSubjects}
//           options={subjectData}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Chapter Dropdown */}
//         <CustomSearchDropdown
//           label="Select Chapter"
//           optionsData={chapterData}
//           selected={selectedChapters}
//           setSelected={setSelectedChapters}
//           placeholder="Search for Chapters..."
//           isRequired={true}
//           onSearchKeyChange={(key) => handleSearchKeyChange(key, "chapter")} // Pass key to handleSearchKeyChange
//         />

//         {/* DPP Dropdown */}
//         <CustomSearchDropdown
//           label="Select DPP"
//           optionsData={dppData}
//           selected={selectedDppIds}
//           setSelected={setSelectedDppIds}
//           placeholder="Search for DPPs..."
//           isRequired={true}
//           onSearchKeyChange={(key) => handleSearchKeyChange(key, "dpp")} // Pass key to handleSearchKeyChange
//         />
//       </div>
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useEffect, useCallback } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import CustomSearchDropdown from "./FileComp4";
// import DropDownMultipleSelection from "../Reports/components/FieldsComponent";
// import _ from "lodash";

// const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
//   // Remove duplicates from the array
//   return _.uniqBy(
//     dataArray.map((item) => ({
//       id: item[idField],
//       label: item[nameField],
//     })),
//     "id"
//   );
// };

// const POP = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]);

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);

//   const [searchKey, setSearchKey] = useState(null);
//   const [searchColumn, setSearchColumn] = useState(null);

//   const fetchDropdownData = async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=1`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: selectedBatches,
//             subject_ids: selectedSubjects,
//             chapter_ids: selectedChapters,
//             assessment_ids: selectedDppIds,
//             student_ids: selectedStudents,
//             search_key: searchKey, // Pass the current search key
//             search_column: searchColumn, // Pass the current search column
//           }),
//         }
//       );
//       const data = await response.json();

//       setBatchData(
//         mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
//       );
//       setSubjectData(
//         mapDataToDropdownFormat(
//           data.subject_list,
//           "subject_id",
//           "subject_name"
//         )
//       );
//       setChapterData(
//         mapDataToDropdownFormat(
//           data.chapter_list,
//           "chapter_id",
//           "chapter_name"
//         )
//       );
//       setDppData(
//         mapDataToDropdownFormat(
//           data.assessment_list,
//           "assessment_id",
//           "assessment_name"
//         )
//       );
//       setStudentData(
//         mapDataToDropdownFormat(
//           data.student_list,
//           "student_id",
//           "student_name"
//         )
//       );
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchDropdownData();
//   }, [searchKey, searchColumn, selectedBatches, selectedSubjects, selectedChapters, selectedDppIds, selectedStudents]);

//   const handleSearchKeyChange = (key, dropdownType) => {
//     // For Chapter, DPP, and Student, check if at least 3 characters are typed
//     if (dropdownType === "chapter" || dropdownType === "dpp" || dropdownType === "student") {
//       if (key.length >= 3) {
//         setSearchKey(key);
//         setSearchColumn(dropdownType); // Use either 'chapter', 'dpp', or 'student'
//       } else {
//         setSearchKey(null); // Before 3 characters, do not search
//         setSearchColumn(null);
//       }
//     } else {
//       // For other dropdowns (Batch, Subject, etc.), set searchKey and searchColumn to null
//       setSearchKey(null);
//       setSearchColumn(null);
//     }
//   };

//   return (
//     <div>
//       <div className="row-cs-uni" style={{padding:"30px"}}>
//         {/* Student Dropdown */}
//         <CustomSearchDropdown
//           label="Select Student"
//           optionsData={studentData}
//           selected={selectedStudents}
//           setSelected={setSelectedStudents}
//           placeholder="Search for Students..."
//           isRequired={true}
//           onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")} // Pass key to handleSearchKeyChange
//         />

//         {/* Batch Dropdown */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Batch"
//           selected={selectedBatches}
//           setSelected={setSelectedBatches}
//           options={batchData}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Subject Dropdown */}
//         <DropDownMultipleSelection
//           width="300px"
//           label="Select Subject"
//           selected={selectedSubjects}
//           setSelected={setSelectedSubjects}
//           options={subjectData}
//           customWidth="100%"
//           isRequired={true}
//           showSelectAll={true}
//         />

//         {/* Chapter Dropdown */}
//         <CustomSearchDropdown
//           label="Select Chapter"
//           optionsData={chapterData}
//           selected={selectedChapters}
//           setSelected={setSelectedChapters}
//           placeholder="Search for Chapters..."
//           isRequired={true}
//           onSearchKeyChange={(key) => handleSearchKeyChange(key, "chapter")} // Pass key to handleSearchKeyChange
//         />

//         {/* DPP Dropdown */}
//         <CustomSearchDropdown
//           label="Select DPP"
//           optionsData={dppData}
//           selected={selectedDppIds}
//           setSelected={setSelectedDppIds}
//           placeholder="Search for DPPs..."
//           isRequired={true}
//           onSearchKeyChange={(key) => handleSearchKeyChange(key, "dpp")} // Pass key to handleSearchKeyChange
//         />
//       </div>
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useEffect, useCallback } from "react";
// import { FULL_API_BASE_URL } from "../../Config/Config";
// import CustomSearchDropdown from "./FileComp5";
// import DropDownMultipleSelection2 from "../Reports/components/FieldsComponent";
// import _ from "lodash";

// const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
//   // Remove duplicates from the array
//   return _.uniqBy(
//     dataArray.map((item) => ({
//       id: item[idField],
//       label: item[nameField],
//     })),
//     "id"
//   );
// };

// const POP = ({ dataClient }) => {
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]);

//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);

//   const [searchKey, setSearchKey] = useState(null);
//   const [searchColumn, setSearchColumn] = useState(null);

//   const fetchDropdownData = useCallback(async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=1`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: selectedBatches,
//             subject_ids: selectedSubjects,
//             chapter_ids: selectedChapters,
//             assessment_ids: selectedDppIds,
//             student_ids: selectedStudents,
//             search_key: searchKey,
//             search_column: searchColumn,
//           }),
//         }
//       );

//       const data = await response.json();

//       // Mapping data to proper format for Student and Chapter dropdowns
//       setBatchData(
//         mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
//       );

//       setSubjectData(
//         mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
//       );

//       // Ensure unique chapters by chapter_id
//       const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
//       setChapterData(
//         uniqueChapters.map((item) => ({
//           id: item.chapter_id,
//           chapter_name: item.chapter_name, // Field for Chapter Name
//           subject_name: item.subject_name, // Field for Subject Name
//           batch_name: item.batch_name, // Field for Batch Name
//         }))
//       );

//       // Ensure unique students by student_id
//       const uniqueStudents = _.uniqBy(data.student_list, "student_id");
//       setStudentData(
//         uniqueStudents.map((item) => ({
//           id: item.student_id,
//           student_name: item.student_name, // Field for Student Name
//           roll_number: item.roll_number, // Field for Roll Number
//           batch_name: item.batch_name, // Field for Batch Name
//         }))
//       );

//       const uniqueAssessments = _.uniqBy(
//         data.assessment_list.filter(
//           (assessment) => assessment.assessment_type_id === 1
//         ),
//         "assessment_id"
//       );

//       setDppData(
//         uniqueAssessments.map((item) => ({
//           id: item.assessment_id,
//           assessment_name: item.assessment_name,
//           chapter_name: item.chapter_name,
//           subject_name: item.subject_name,
//         }))
//       );
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//     }
//   }, [
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     searchKey,
//     searchColumn,
//   ]);

//   // Handle dropdown close to trigger data fetching
//   const handleDropdownClose = () => {
//     fetchDropdownData(); // Call function to update dropdowns
//   };

//   return (
//     <div style={{ padding: "30px" }}>
//       {/* Batch Dropdown */}
//       <DropDownMultipleSelection2
//         label="Select Batch"
//         width="13vw"
//         selected={selectedBatches}
//         setSelected={setSelectedBatches}
//         options={batchData}
//         showSelectAll={true}
//         onDropdownClose={handleDropdownClose} // API call after dropdown closes
//         isRequired={false}
//       />

//       {/* Student Dropdown
//       <CustomSearchDropdown
//         label="Select Student"
//         optionsData={studentData}
//         selected={selectedStudents}
//         setSelected={setSelectedStudents}
//         placeholder="Search for Students..."
//         isRequired={false}
//         showSelectAll={true}
//         onDropdownClose={handleDropdownClose}
//       /> */}

//       {/* Subject Dropdown */}
//       <DropDownMultipleSelection2
//         width="13.5vw"
//         label="Select Subject"
//         selected={selectedSubjects}
//         setSelected={setSelectedSubjects}
//         options={subjectData}
//         customWidth="100%"
//         isRequired={false}
//         showSelectAll={true}
//         onDropdownClose={handleDropdownClose}
//       />

//       {/* Chapter Dropdown
//       <CustomSearchDropdown
//         label="Select Chapter"
//         placeholder="Search for Chapter..."
//         optionsData={chapterData}
//         selected={selectedChapters}
//         setSelected={setSelectedChapters}
//         onDropdownClose={handleDropdownClose}
//       /> */}

//       <CustomSearchDropdown
//         label="Select Student"
//         optionsData={studentData}
//         selected={selectedStudents}
//         setSelected={setSelectedStudents}
//         placeholder="Search for Students..."
//         headers={["Student Name", "Roll Number", "Batch Name"]}
//         optionFields={{
//           option1: "student_name",
//           option2: "roll_number",
//           option3: "batch_name",
//         }}
//         onDropdownClose={handleDropdownClose} // API call after dropdown closes
//         customwidth="20vw"
//       />

//       <CustomSearchDropdown
//         label="Select Chapter"
//         optionsData={chapterData}
//         selected={selectedChapters}
//         setSelected={setSelectedChapters}
//         placeholder="Search for Chapter..."
//         headers={["Chapter Name", "Subject Name", "Batch Name"]}
//         optionFields={{
//           option1: "chapter_name",
//           option2: "subject_name",
//           option3: "batch_name",
//         }}
//         onDropdownClose={handleDropdownClose} // API call after dropdown closes
//         customwidth="20vw"
//       />

//       <CustomSearchDropdown
//         label="Select DPP"
//         optionsData={dppData}
//         selected={selectedDppIds}
//         setSelected={setSelectedDppIds}
//         placeholder="Search for DPP..."
//         headers={["Assessment Name", "Chapter Name", "Subject Name"]}
//         optionFields={{
//           option1: "assessment_name",
//           option2: "chapter_name",
//           option3: "subject_name",
//         }}
//         onDropdownClose={handleDropdownClose} // API call after dropdown closes
//         customwidth="20vw"
//       />
//     </div>
//   );
// };

// export default POP;

// import React, { useEffect, useState } from "react";
// import TableComponent from "../Reports/components/TableCompoenent";
// import dayjs from "dayjs";

// const POP = () => {
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(true);
//   const [isExpanded, setIsExpanded] = useState(true);
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const headers = ["Date", "Day", "Day Type", "Punch In"]; // Ensure headers match data columns

//   const fetchAttendanceData = async () => {
//     setLoading(true); // Set loading state to true while fetching data
//     try {
//       const response = await fetch(
//         "https://live.dse-cc-api.com/coaching-collaborator-api/api/v1/get-student-attendance/?student_id=2&start_date=2024-06-14%2010%3A46%3A01&end_date=2024-10-14%2010%3A46%3A01",
//         {
//           method: "GET",
//           headers: {
//             accept: "application/json",
//           },
//         }
//       );
//       const data = await response.json();
//       // Ensure the data is structured properly for the table
//       if (Array.isArray(data)) {
//         const mappedData = data.map((item) => [
//           item.date_ || "N/A",
//           item.day_ || "N/A",
//           item.day_type || "N/A",
//           item.punch_in || "N/A", // Show "N/A" if punch_in is null
//         ]);
//         setAttendanceData(mappedData);
//       } else {
//         console.error("Unexpected data format:", data);
//       }
//     } catch (error) {
//       console.error("Error fetching attendance data:", error);
//     } finally {
//       setLoading(false); // Set loading state to false after fetching data
//     }
//   };
//   const [items, setItems] = useState([
//     { date: "10/09/24", text: "Fees payment extension requested by wards." },
//     {
//       date: "19/09/24",
//       text: "Student will be absent from 20/09/24 to 25/09/24.",
//     },
//   ]);

//   const [inputValue, setInputValue] = useState("");
//   const [inputWidth, setInputWidth] = useState(200);

//   const handleInputChange = (e) => {
//     setInputValue(e.target.value);
//     setInputWidth(Math.max(200, e.target.value.length * 10)); // Adjust the width dynamically
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && inputValue.trim()) {
//       const newItem = {
//         date: dayjs().format("DD/MM/YY"), // Today's date
//         text: inputValue,
//       };
//       setItems((prevItems) => [...prevItems, newItem]);
//       setInputValue(""); // Clear the input field after submission
//     }
//   };

//   return (
//     <div>
//       <button onClick={fetchAttendanceData} disabled={loading}>
//         {loading ? "Loading..." : "Fetch Attendance"}
//       </button>

//       {/* Render the table only if data is available */}
//       {attendanceData.length > 0 ? (
//         <TableComponent
//           headers={headers}
//           data={attendanceData}
//           searchPlaceholder="Search attendance..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           isExpanded={isExpanded}
//           ReportPageHeader="Attendance Report"

//         />
//       ) : (
//         <p>No attendance data available.</p>
//       )}

// <div>
//           <div
//             style={{
//               backgroundColor: "#D6D6D6",
//               color: "#424342",
//               fontWeight: "700",
//               padding: "10px",
//               boxShadow: "4px 4px 4px 0px #00000040",
//             }}
//           >
//             NOTES
//           </div>
//           <div
//             className="student-dashboard-line-chart"
//             style={{ padding: "10px" }}
//           >
//             <ul className="custom-list">
//               {items.map((item, index) => (
//                 <li key={index}>
//                   <span style={{ color: "grey", marginRight: "5px" }}>
//                     {item.date}
//                   </span>
//                   {item.text}
//                 </li>
//               ))}
//             </ul>
//             <input
//               type="text"
//               value={inputValue}
//               onChange={handleInputChange}
//               onKeyDown={handleKeyDown}
//               style={{ width: `${inputWidth}px`, padding: "5px" }}
//               placeholder="Type your note and press Enter"
//             />
//           </div>
//         </div>
//     </div>
//   );
// };

// export default POP;

// import React, { useState, useRef, useEffect } from "react";
// import dayjs from "dayjs";

// const POP = () => {
//   const [items, setItems] = useState([
//     { date: "10/09/24", text: "Fees payment extension requested by wards." },
//     {
//       date: "19/09/24",
//       text: "Student will be absent from 20/09/24 to 25/09/24.",
//     },
//     {
//       date: "24/09/24",
//       text: "Student will be absent from 20/09/24 to 25/09/24.",
//     },
//     {
//       date: "30/09/24",
//       text: "Student will be absent from 20/09/24 to 25/09/24.",
//     },
//   ]);

//   const [inputValue, setInputValue] = useState("");
//   const [inputVisible, setInputVisible] = useState(false);
//   const userName = "User Name";

//   const textareaRef = useRef(null);

//   const handleInputChange = (e) => {
//     setInputValue(e.target.value);
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       // Submit on Enter without Shift
//       e.preventDefault();
//       if (inputValue.trim()) {
//         const newItem = {
//           date: dayjs().format("DD/MM/YY"), // Today's date
//           text: inputValue,
//         };
//         setItems((prevItems) => [...prevItems, newItem]);
//         setInputValue(""); // Clear the input field
//         setInputVisible(false); // Hide the input field after submission
//         // Reset the textarea height after submission
//         if (textareaRef.current) {
//           textareaRef.current.style.height = "auto";
//         }
//       }
//     }
//   };

//   // Dynamically adjust textarea height as the user types
//   useEffect(() => {
//     if (textareaRef.current) {
//       textareaRef.current.style.height = "auto"; // Reset height
//       textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set to scrollHeight
//     }
//   }, [inputValue]); // Re-run effect when inputValue changes

//   const handleDoubleClick = () => {
//     setInputVisible(true); // Show the input field on double-click
//   };

//   return (
//     <div>
//       <div
//         style={{
//           backgroundColor: "#D6D6D6",
//           color: "#424342",
//           fontWeight: "700",
//           padding: "10px",
//           boxShadow: "4px 4px 4px 0px #00000040",
//         }}
//       >
//         NOTES
//       </div>
//       <div className="student-dashboard-line-chart" style={{ padding: "10px" }}>
//         <ul className="custom-list">
//           {items.slice(0, -1).map((item, index) => (
//             <li
//               key={index}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 whiteSpace: "pre-wrap", // Preserve whitespace and newlines
//               }}
//             >
//               <span style={{ color: "grey", marginRight: "5px" }}>
//                 {item.date}
//               </span>
//               <span style={{ color: "grey", marginRight: "5px" }}>
//                 [ {userName} ]
//               </span>
//               {item.text}
//             </li>
//           ))}
//         </ul>
//         <div
//           onDoubleClick={handleDoubleClick}
//           style={{ display: "flex", alignItems: "center" }}
//         >
//           <span
//             style={{
//               width: "8px",
//               height: "8px",
//               backgroundColor: "black",
//               borderRadius: "50%",
//               display: "inline-block",
//               marginRight: "12px",
//             }}
//           ></span>
//           <span style={{ color: "grey", marginRight: "5px" }}>
//             {items[items.length - 1]?.date}
//           </span>
//           <span style={{ color: "grey", marginRight: "5px" }}>
//             [ {userName} ]
//           </span>
//           <span
//             style={{
//               whiteSpace: "pre-wrap", // Preserve whitespace and newlines
//             }}
//           >
//             {items[items.length - 1]?.text}
//           </span>
//         </div>

//         {inputVisible && (
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginTop: "10px",
//             }}
//           >
//             <span
//               style={{
//                 width: "8px",
//                 height: "8px",
//                 backgroundColor: "black",
//                 borderRadius: "50%",
//                 display: "inline-block",
//                 marginRight: "12px",
//               }}
//             ></span>
//             <span style={{ color: "grey", marginRight: "5px" }}>
//               {dayjs().format("DD/MM/YY")}
//             </span>
//             <span style={{ color: "grey", marginRight: "5px" }}>
//               [ {userName} ]
//             </span>
//             <textarea
//               ref={textareaRef}
//               value={inputValue}
//               onChange={handleInputChange}
//               onKeyDown={handleKeyDown}
//               style={{
//                 width: "15vw",
//                 maxHeight: "20vh",
//                 border: "none",
//                 backgroundColor: "transparent",
//                 resize: "none", // Disable manual resizing
//                 overflow: "hidden", // Prevent scrollbars from appearing
//                 whiteSpace: "pre-wrap", // Allow text wrapping within the textarea
//                 wordWrap: "break-word", // Ensure long words break to fit within the textarea
//                 outline:"none"
//               }}
//               rows={1} // Initial rows
//               placeholder="Type your note and press Enter"
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default POP;

// import React from "react";
// import ReactSpeedometer from "react-d3-speedometer";

// const Pop = () => {
//   return (
//     <ReactSpeedometer
//       value={666}
//       currentValueText="Student Readyness meter"
//       maxValue={1000}
//       height={500}
//       width={500}
//       customSegmentLabels={[
//         {
//           text: "Very Bad",
//           position: "INSIDE",
//           color: "#555",
//         },
//         {
//           text: "Bad",
//           position: "INSIDE",
//           color: "#555",
//         },
//         {
//           text: "Ok",
//           position: "INSIDE",
//           color: "#555",
//           fontSize: "19px",
//         },
//         {
//           text: "Good",
//           position: "INSIDE",
//           color: "#555",
//         },
//         {
//           text: "Very Good",
//           position: "INSIDE",
//           color: "#555",
//         },
//       ]}
//     />
//   );
// };

// export default Pop;

// import React, { useEffect, useState, useRef } from "react";
// import dayjs from "dayjs";

// const POP = () => {
//   const [items, setItems] = useState([
//     { date: "10/09/24", text: "Fees payment extension requested by wards.", isChecked: false, isRed: false },
//     { date: "19/09/24", text: "Student will be absent from 20/09/24 to 25/09/24.", isChecked: false, isRed: false },
//   ]);

//   const [inputValue, setInputValue] = useState("");
//   const [inputVisible, setInputVisible] = useState(false);
//   const [isChecked, setIsChecked] = useState(false); // Track if checkbox is selected
//   const textareaRef = useRef(null);
//   const userName = "User Name";

//   const handleInputChange = (e) => {
//     setInputValue(e.target.value);
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();

//       if (inputValue.trim()) {
//         const isRed = inputValue.startsWith("@KeepRed"); // Check if note starts with "@KeepRed"
//         const cleanText = isRed ? inputValue.replace("@KeepRed", "").trim() : inputValue; // Remove "@KeepRed" from the text

//         const newItem = {
//           date: dayjs().format("DD/MM/YY"), // Today's date
//           text: cleanText, // Store the cleaned text
//           isChecked: isChecked, // Save the checkbox state
//           isRed: isRed || isChecked, // Set isRed if @KeepRed is typed or checkbox is checked
//         };

//         setItems((prevItems) => [...prevItems, newItem]);
//         setInputValue(""); // Clear the input field
//         setInputVisible(false); // Hide the input field after submission
//         setIsChecked(false); // Reset the checkbox state after saving

//         // Reset the textarea height after submission
//         if (textareaRef.current) {
//           textareaRef.current.style.height = "auto";
//         }
//       }
//     }
//   };

//   // Dynamically adjust textarea height as the user types
//   useEffect(() => {
//     if (textareaRef.current) {
//       textareaRef.current.style.height = "auto"; // Reset height
//       textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set to scrollHeight
//     }
//   }, [inputValue]);

//   const handleCheckboxChange = () => {
//     setIsChecked((prev) => !prev); // Toggle checkbox state
//   };

//   const handleDoubleClick = () => {
//     setInputVisible(true); // Show the input field on double-click
//   };

//   return (
//     <div className="student-dashboard-content">
//       <div>
//         <div
//           style={{
//             backgroundColor: "#D6D6D6",
//             color: "#424342",
//             fontWeight: "700",
//             padding: "10px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//           }}
//         >
//           NOTES
//         </div>
//         <div
//           className="student-dashboard-line-chart"
//           style={{ padding: "10px" }}
//         >
//           <ul className="custom-list">
//             {items.slice(0, -1).map((item, index) => (
//               <li
//                 key={index}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   whiteSpace: "pre-wrap",
//                   color: item.isRed ? "#FA4741" : "#424242", // Apply red color if isRed is true
//                 }}
//               >
//                 <span style={{ color: "grey", marginRight: "5px" }}>
//                   {item.date}
//                 </span>
//                 <span style={{ color: "grey", marginRight: "5px" }}>
//                   [{userName}]
//                 </span>
//                 {item.text}
//               </li>
//             ))}
//           </ul>

//           <div
//             onDoubleClick={handleDoubleClick}
//             style={{ display: "flex", alignItems: "center" }}
//           >
//             <span
//               style={{
//                 width: "8px",
//                 height: "8px",
//                 backgroundColor: "#424242",
//                 borderRadius: "50%",
//                 display: "inline-block",
//                 marginRight: "12px",
//               }}
//             ></span>
//             <span style={{ color: "grey", marginRight: "5px" }}>
//               {items[items.length - 1]?.date}
//             </span>
//             <span style={{ color: "grey", marginRight: "5px" }}>
//               [{userName}]
//             </span>
//             <span
//               style={{
//                 whiteSpace: "pre-wrap",
//                 color: items[items.length - 1]?.isRed ? "#FA4741" : "#424242", // Apply red color to the last saved item if isRed is true
//               }}
//             >
//               {items[items.length - 1]?.text}
//             </span>
//           </div>

//           {inputVisible && (
//             <>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   marginTop: "10px",
//                 }}
//               >
//                 <span
//                   style={{
//                     width: "8px",
//                     height: "8px",
//                     backgroundColor: "#424242",
//                     borderRadius: "50%",
//                     display: "inline-block",
//                     marginRight: "12px",
//                   }}
//                 ></span>
//                 <span style={{ color: "grey", marginRight: "5px" }}>
//                   {dayjs().format("DD/MM/YY")}
//                 </span>
//                 <span style={{ color: "grey", marginRight: "5px" }}>
//                   [{userName}]
//                 </span>
//                 <textarea
//                   ref={textareaRef}
//                   value={inputValue}
//                   onChange={handleInputChange}
//                   onKeyDown={handleKeyDown}
//                   style={{
//                     width: "30vw",
//                     maxHeight: "20vh",
//                     border: "none",
//                     backgroundColor: "transparent",
//                     resize: "none",
//                     overflow: "hidden",
//                     whiteSpace: "pre-wrap",
//                     wordWrap: "break-word",
//                     outline: "none",
//                     color: isChecked || inputValue.startsWith("@KeepRed")
//                       ? "#FA4741"
//                       : "#424242", // Textarea turns red if checkbox is checked or if @KeepRed is typed
//                   }}
//                   rows={1}
//                   placeholder="Type your note and press Enter"
//                 />
//               </div>
//               <input
//                 style={{ marginLeft: "8.8vw", marginTop: "5px" }}
//                 type="checkbox"
//                 checked={isChecked}
//                 onChange={handleCheckboxChange} // Handle checkbox state for new note
//               />
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default POP;

// import React from "react";
// import AImage from "./A.webp";
// import DImage from "./D.webp";
// import FImage from "./F.webp";
// import TImage from "./T.webp";

// const pop = () => {
//   const activityIcons = [AImage, DImage, FImage, TImage]; // Array of images

//   return (
//     <div style={{ padding: "20px" }}>
//       <div
//         style={{
//           backgroundColor: "#D6D6D6",
//           color: "#424342",
//           fontWeight: "700",
//           padding: "10px",
//           boxShadow: "4px 4px 4px 0px #00000040",
//         }}
//       >
//         Recent Activity
//       </div>
//       <div className="card1-student-dashboard recent-activity">
//         <div className="timeline-wrapper">
//           <div className="timeline">
//             {[
//               {
//                 time: "16/10/24",
//                 text: "Submitted DPP-2 Physics.",
//               },
//               {
//                 time: "15/10/24",
//                 text: "Test Submitted Test-5 Chemistry.",
//               },
//               {
//                 time: "13/10/24",
//                 text: "Submitted DPP-3 Biology.",
//               },
//               {
//                 time: "10/10/24",
//                 text: "Fees - part payment.",
//               },
//               { time: "09/10/24", text: "Submitted DPP-3 Zoology." },
//               {
//                 time: "05/10/24",
//                 text: "Absent.",
//               },
//               {
//                 time: "01/10/24",
//                 text: "Test Submitted TTS-4 Chemistry.",
//               },
//               {
//                 time: "30/09/24",
//                 text: "Test Submitted TTS-3 Chemistry.",
//               },
//               { time: "29/09/24", text: "Absent." },
//               {
//                 time: "28/09/24",
//                 text: "Submitted DPP-2 Zoology.",
//               },
//               {
//                 time: "21/09/24",
//                 text: "Submitted DPP-1 Biology.",
//               },
//               {
//                 time: "19/09/24",
//                 text: "Submitted DPP-1 Zoology.",
//               },
//               {
//                 time: "16/09/24",
//                 text: "Submitted DPP-1 Physics.",
//               },
//               {
//                 time: "10/09/24",
//                 text: "Fees - part payment.",
//               },
//               {
//                 time: "10/09/24",
//                 text: "Account created.",
//               },
//             ].map((activity, index) => (
//               <div className="timeline-item" key={index}>
//                 {/* Display the icon */}
//                 <img
//                   src={activityIcons[index % activityIcons.length]} // Cycle through images
//                   alt="activity-icon"
//                   style={{
//                     width: "20px",
//                     height: "20px",
//                     borderRadius: "50%",
//                     zIndex:"20"
//                   }}
//                 />
//                 <div className="timeline-time">{activity.time}</div>
//                 <div className="timeline-text">{activity.text}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default pop;

// import React from "react";

// const POP = () => {
//   return (
//     <div
//       style={{
//         display: "grid",
//         gridTemplateColumns: "1fr 1fr 1fr",
//         alignItems: "start",
//         gap: "10px",
//         position: "relative",
//       }}
//     >
//       {/* First Column: First Two Divs in a Column */}
//       <div style={{ gridColumn: "1", marginLeft: "18px" }}>
//         <div
//           style={{
//             marginBottom: "10px",
//             padding: "10px",
//             width: "20vw",
//             border: "1px dotted grey",
//           }}
//           id="subjectDiv"
//         >
//           <ul>
//             <li style={{ padding: "4px" }}>PHYSICS</li>
//             <li style={{ padding: "4px" }}>ZOOLOGY</li>
//             <li style={{ padding: "4px" }}>CHEMISTRY</li>
//             <li style={{ padding: "4px" }}>BIOLOGY</li>
//           </ul>
//         </div>
//         <div
//           style={{
//             padding: "10px",
//             width: "20vw",
//             border: "1px dotted grey",
//           }}
//         >
//           <ul>
//             <li style={{ padding: "4px" }}>SINGLE CORRECT</li>
//             <li style={{ padding: "4px" }}>MULTI CORRECT</li>
//             <li style={{ padding: "4px" }}>MATCH THE COLUMNS</li>
//             <li style={{ padding: "4px" }}>FILL IN THE BLANKS</li>
//           </ul>
//         </div>
//       </div>

//       {/* Middle Column:  Buttons */}
//       <div
//         style={{
//           gridColumn: "2",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           position: "relative",
//         }}
//       >
//         {/* Center Buttons */}
//         <button style={{ marginTop: "8vh", position: "relative" }} id="addSubjectButton">
//           ADD SUBJECT
//         </button>
//         <button style={{ marginTop: "3vh" }}>ADD SECTION</button>
//       </div>

//       {/* Right Column: Last Div */}
//       <div
//         style={{
//           gridColumn: "3",
//           padding: "10px",
//           width: "20vw",
//           border: "1px dotted grey",
//         }}
//       >
//         <ul>
//           PHYSICS
//           <li style={{ marginLeft: "27px" }}>SINGLE</li>
//           <li style={{ marginLeft: "27px" }}>MATCH THE COLUMNS</li>
//           <li style={{ marginLeft: "27px" }}>FILL IN THE BLANKS</li>
//         </ul>
//         <ul>
//           CHEMISTRY
//           <li style={{ marginLeft: "27px" }}>SINGLE</li>
//           <li style={{ marginLeft: "27px" }}>MATCH THE COLUMNS</li>
//           <li style={{ marginLeft: "27px" }}>FILL IN THE BLANKS</li>
//         </ul>
//         <ul>
//           ZOOLOGY
//           <li style={{ marginLeft: "27px" }}>SINGLE</li>
//           <li style={{ marginLeft: "27px" }}>MATCH THE COLUMNS</li>
//           <li style={{ marginLeft: "27px" }}>FILL IN THE BLANKS</li>
//         </ul>
//       </div>

//       {/* SVG Lines */}
//       <svg
//         height="100%"
//         width="100%"
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           pointerEvents: "none",
//         }}
//       >
//         <line
//           x1="20.9vw"
//           y1="calc(9.3vh)"
//           x2="calc(50% - 48px)"
//           y2="calc(8vh + 10px)"
//           style={{ stroke: "pink", strokeWidth: 2 }}
//         />
//         <line
//           x1="calc(53% )"
//           y1="calc(8vh + 10px)"
//           x2="calc(100% - 27.5vw - 10px)"
//           y2="calc(8vh + 10px)"
//           style={{ stroke: "pink", strokeWidth: 2 }}
//         />
//       </svg>
//     </div>
//   );
// };

// export default POP;

// import React, { useState } from "react";

// const POP = () => {
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [sectionSelections, setSectionSelections] = useState({});
//   const [addedSubjects, setAddedSubjects] = useState({});

//   const subjectList = ["PHYSICS", "ZOOLOGY", "CHEMISTRY", "BIOLOGY", "MATHS"];
//   const sectionList = [
//     "SINGLE CORRECT",
//     "MULTI CORRECT",
//     "MATCH THE COLUMNS",
//     "FILL IN THE BLANKS",
//   ];

//   const sectionDescriptions = {
//     "SINGLE CORRECT": "There is only one correct option",
//     "MULTI CORRECT": "There are multiple correct options",
//     "MATCH THE COLUMNS": "Match the column to the correct option",
//     "FILL IN THE BLANKS": "Fill in the appropriate value in the blanks",
//   };

//   const handleCheckboxChange = (subject, section) => {
//     setSectionSelections((prev) => ({
//       ...prev,
//       [subject]: {
//         ...prev[subject],
//         [section]: !prev[subject]?.[section],
//       },
//     }));
//   };

//   const handleSave = () => {
//     setAddedSubjects((prev) => ({
//       ...prev,
//       ...Object.keys(sectionSelections).reduce((acc, subject) => {
//         const selectedSections = Object.keys(sectionSelections[subject]).filter(
//           (section) => sectionSelections[subject][section]
//         );
//         if (selectedSections.length > 0) {
//           acc[subject] = selectedSections;
//         }
//         return acc;
//       }, {}),
//     }));
//     setSectionSelections({});
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div className="container-UP" style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <p className="title-cb">Create New Test Series V2</p>
//           <div className="mb-2-UP">
//             <button className="cr-cancel-btn me-cs4">CANCEL</button>
//             <button className="cr-create-btn" onClick={handleSave}>
//               SAVE
//             </button>
//           </div>
//         </div>
//         <hr
//           style={{ color: "red", backgroundColor: "red", marginTop: "5px" }}
//         />
//       </div>

//       <h3 style={{ padding: "15px", color: "grey" }}>SUBJECTS</h3>

//       <div className="row-cs-uni">
//         <div className="col-cs4">
//           <div
//             style={{
//               display: "grid",

//               gap: "20px",
//               alignItems: "start",
//               padding: "15px",
//             }}
//           >
//             {subjectList.map((subject) => (
//               <div
//                 key={subject}
//                 style={{
//                   width:"20vw",
//                   padding: "10px",
//                   border: "1px dotted grey",
//                 }}
//               >
//                 <div
//                   onClick={() => setSelectedSubject(subject)}
//                   style={{
//                     padding: "4px",
//                     backgroundColor:
//                       selectedSubject === subject ? "#FFBD20" : "transparent",
//                     cursor: "pointer",
//                     fontWeight: "bold",
//                     textAlign: "center",
//                   }}
//                 >
//                   {subject}
//                 </div>
//                 {sectionList.map((section) => (
//                   <div
//                     key={section}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       padding: "4px",

//                     }}
//                   >
//                     <input
//                       type="checkbox"
//                       checked={!!sectionSelections[subject]?.[section]}
//                       onChange={() => handleCheckboxChange(subject, section)}
//                       style={{ marginRight: "10px" }}
//                     />
//                     <label>{section}</label>
//                   </div>
//                 ))}
//               </div>
//             ))}
//           </div>
//         </div>
//         <div
//           className="col-cs2"
//           style={{ marginRight: "15px", marginTop: "15px" }}
//         >
//           <div style={{ padding: "10px", border: "1px dotted orange" }}>
//             <h4 style={{paddingBottom:"10px"}}>Section Descriptions</h4>
//             {Object.entries(sectionDescriptions).map(
//               ([section, description]) => (
//                 <div key={section} style={{ marginBottom: "10px" }}>
//                   <strong>{section}</strong>: {description}
//                 </div>
//               )
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default POP;

// import React, { useState } from "react";
// import "katex/dist/katex.min.css";
// import Latex from "react-latex-next";
// import Piechart3d from "../../Components/GraphPlain3dComponent/GraphPlain3dComponent";
// const Pop = () => {
//   const [latexInput, setLatexInput] = useState("");

//   const handleChange = (event) => {
//     setLatexInput(event.target.value);
//   };

//   return (
//     <div>
//       <input
//         type="text"
//         value={latexInput}
//         onChange={handleChange}
//         placeholder="Enter LaTeX here"
//         style={{ width: "100%", padding: "10px", marginBottom: "20px" }}
//       />
//       <div>
//         <Latex>{`Here is an inline equation: $E = mc^2$ and a display equation: $$\\int_0^\\infty e^{-x} dx = 1$$`}</Latex>
//       </div>
//       <div>
//         <Latex>{latexInput}</Latex>
//       </div>
//     </div>
//   );
// };

// export default Pop;
// const apiData = {
//   ques_paper_id: 450,
//   ques_paper_name: "Multiple-Filter-tags",
//   description: "Multiple-Filter-tags",
//   created_by: "dbose10",
//   subjects: [
//     {
//       subject_name: "Physics",
//       subject_id: 1,
//       easy: "10",
//       medium: "20",
//       tough: "30",
//       ques_type_1: "1",
//       ques_type_2: "5",
//       ques_type_3: "8",
//       ques_type_4: "0",
//       chapters: [
//         {
//           chapter_name: "Mechanics",
//           chapter_id: 101,
//           easy: "10",
//           medium: "20",
//           tough: "30",
//           ques_type_1: "1",
//           ques_type_2: "5",
//           ques_type_3: "8",
//           ques_type_4: "0",
//           topics: [
//             {
//               topic_name: "Kinematics",
//               topic_id: 1001,
//               easy: "10",
//               medium: "20",
//               tough: "30",
//               ques_type_1: "1",
//               ques_type_2: "5",
//               ques_type_3: "8",
//               ques_type_4: "0",
//             },
//             {
//               topic_name: "Dynamics",
//               topic_id: 1002,
//               easy: "10",
//               medium: "20",
//               tough: "30",
//               ques_type_1: "1",
//               ques_type_2: "5",
//               ques_type_3: "8",
//               ques_type_4: "0",
//             },
//             {
//               topic_name: "Thermodynamics",
//               topic_id: 1003,
//               easy: "20",
//               medium: "10",
//               tough: "30",
//               ques_type_1: "2",
//               ques_type_2: "3",
//               ques_type_3: "1",
//               ques_type_4: "4",
//             },
//             {
//               topic_name: "Thermodynamics",
//               topic_id: 1005,
//               easy: "20",
//               medium: "10",
//               tough: "30",
//               ques_type_1: "2",
//               ques_type_2: "3",
//               ques_type_3: "1",
//               ques_type_4: "4",
//             },
//           ],
//         },
//       ],
//     },
//     {
//       subject_name: "Chemistry",
//       subject_id: 2,
//       easy: "15",
//       medium: "25",
//       tough: "20",
//       ques_type_1: "4",
//       ques_type_2: "6",
//       ques_type_3: "3",
//       ques_type_4: "2",
//       chapters: [
//         {
//           chapter_name: "Physical Chemistry",
//           chapter_id: 201,
//           easy: "8",
//           medium: "12",
//           tough: "10",
//           ques_type_1: "1",
//           ques_type_2: "3",
//           ques_type_3: "1",
//           ques_type_4: "1",
//           topics: [
//             {
//               topic_name: "Atomic Structure",
//               topic_id: 2001,
//               easy: "5",
//               medium: "7",
//               tough: "5",
//               ques_type_1: "1",
//               ques_type_2: "2",
//               ques_type_3: "1",
//               ques_type_4: "0",
//             },
//             {
//               topic_name: "Chemical Bonding",
//               topic_id: 2002,
//               easy: "3",
//               medium: "5",
//               tough: "5",
//               ques_type_1: "0",
//               ques_type_2: "1",
//               ques_type_3: "0",
//               ques_type_4: "1",
//             },
//           ],
//         },
//         {
//           chapter_name: "Organic Chemistry",
//           chapter_id: 202,
//           easy: "7",
//           medium: "13",
//           tough: "10",
//           ques_type_1: "2",
//           ques_type_2: "3",
//           ques_type_3: "2",
//           ques_type_4: "1",
//           topics: [
//             {
//               topic_name: "Hydrocarbons",
//               topic_id: 2003,
//               easy: "4",
//               medium: "6",
//               tough: "5",
//               ques_type_1: "1",
//               ques_type_2: "1",
//               ques_type_3: "1",
//               ques_type_4: "0",
//             },
//             {
//               topic_name: "Alcohols",
//               topic_id: 2004,
//               easy: "3",
//               medium: "7",
//               tough: "5",
//               ques_type_1: "1",
//               ques_type_2: "2",
//               ques_type_3: "1",
//               ques_type_4: "1",
//             },
//           ],
//         },
//       ],
//     },
//     {
//       subject_name: "Biology",
//       subject_id: 3,
//       easy: "18",
//       medium: "16",
//       tough: "12",
//       ques_type_1: "5",
//       ques_type_2: "7",
//       ques_type_3: "2",
//       ques_type_4: "4",
//       chapters: [
//         {
//           chapter_name: "Cell Biology",
//           chapter_id: 301,
//           easy: "10",
//           medium: "8",
//           tough: "6",
//           ques_type_1: "2",
//           ques_type_2: "3",
//           ques_type_3: "1",
//           ques_type_4: "1",
//           topics: [
//             {
//               topic_name: "Cell Structure",
//               topic_id: 3001,
//               easy: "6",
//               medium: "4",
//               tough: "2",
//               ques_type_1: "1",
//               ques_type_2: "2",
//               ques_type_3: "0",
//               ques_type_4: "0",
//             },
//             {
//               topic_name: "Cell Cycle",
//               topic_id: 3002,
//               easy: "4",
//               medium: "4",
//               tough: "4",
//               ques_type_1: "1",
//               ques_type_2: "1",
//               ques_type_3: "1",
//               ques_type_4: "1",
//             },
//           ],
//         },
//         {
//           chapter_name: "Genetics",
//           chapter_id: 302,
//           easy: "8",
//           medium: "8",
//           tough: "6",
//           ques_type_1: "3",
//           ques_type_2: "4",
//           ques_type_3: "1",
//           ques_type_4: "3",
//           topics: [
//             {
//               topic_name: "Mendelian Genetics",
//               topic_id: 3003,
//               easy: "5",
//               medium: "4",
//               tough: "3",
//               ques_type_1: "1",
//               ques_type_2: "2",
//               ques_type_3: "0",
//               ques_type_4: "1",
//             },
//             {
//               topic_name: "Molecular Genetics",
//               topic_id: 3004,
//               easy: "3",
//               medium: "4",
//               tough: "3",
//               ques_type_1: "2",
//               ques_type_2: "2",
//               ques_type_3: "1",
//               ques_type_4: "2",
//             },
//           ],
//         },
//       ],
//     },
//     {
//       subject_name: "Maths",
//       subject_id: 4,
//       easy: "22",
//       medium: "14",
//       tough: "14",
//       ques_type_1: "7",
//       ques_type_2: "5",
//       ques_type_3: "3",
//       ques_type_4: "2",
//       chapters: [
//         {
//           chapter_name: "Algebra",
//           chapter_id: 401,
//           easy: "10",
//           medium: "7",
//           tough: "6",
//           ques_type_1: "2",
//           ques_type_2: "2",
//           ques_type_3: "1",
//           ques_type_4: "1",
//           topics: [
//             {
//               topic_name: "Quadratic Equations",
//               topic_id: 4001,
//               easy: "4",
//               medium: "2",
//               tough: "1",
//               ques_type_1: "1",
//               ques_type_2: "0",
//               ques_type_3: "0",
//               ques_type_4: "0",
//             },
//             {
//               topic_name: "Sequences and Series",
//               topic_id: 4002,
//               easy: "6",
//               medium: "5",
//               tough: "5",
//               ques_type_1: "1",
//               ques_type_2: "2",
//               ques_type_3: "1",
//               ques_type_4: "1",
//             },
//           ],
//         },
//         {
//           chapter_name: "Calculus",
//           chapter_id: 402,
//           easy: "12",
//           medium: "7",
//           tough: "8",
//           ques_type_1: "5",
//           ques_type_2: "3",
//           ques_type_3: "2",
//           ques_type_4: "1",
//           topics: [
//             {
//               topic_name: "Limits and Continuity",
//               topic_id: 4003,
//               easy: "8",
//               medium: "4",
//               tough: "3",
//               ques_type_1: "2",
//               ques_type_2: "1",
//               ques_type_3: "1",
//               ques_type_4: "0",
//             },
//             {
//               topic_name: "Differentiation",
//               topic_id: 4004,
//               easy: "4",
//               medium: "3",
//               tough: "5",
//               ques_type_1: "3",
//               ques_type_2: "2",
//               ques_type_3: "1",
//               ques_type_4: "1",
//             },
//           ],
//         },
//       ],
//     },
//   ],
// };

import React from "react";
import SmallPie from "../../Components/GraphPlain3dComponent/GraphPlain3dComponent";
import SingleBigPie from "../../Components/GraphPlain3dComponent/Graph3DSelector";
import "../../Components/OneComponent.css";

function POP() {
  const apiData = {
    ques_paper_id: 450,
    ques_paper_name: "Multiple-Filter-tags",
    description: "Multiple-Filter-tags",
    created_by: "dbose10",
    subjects: [
      {
        subject_name: "Physics",
        subject_id: 1,
        easy: "10",
        medium: "20",
        tough: "30",
        ques_type_1: "1",
        ques_type_2: "5",
        ques_type_3: "8",
        ques_type_4: "0",
        chapters: [
          {
            chapter_name: "Mechanics",
            chapter_id: 101,
            easy: "10",
            medium: "20",
            tough: "30",
            ques_type_1: "1",
            ques_type_2: "5",
            ques_type_3: "8",
            ques_type_4: "0",
            topics: [
              {
                topic_name: "Kinematics",
                topic_id: 1001,
                easy: "10",
                medium: "20",
                tough: "30",
                ques_type_1: "1",
                ques_type_2: "5",
                ques_type_3: "8",
                ques_type_4: "0",
              },
              {
                topic_name: "Dynamics",
                topic_id: 1002,
                easy: "10",
                medium: "20",
                tough: "30",
                ques_type_1: "1",
                ques_type_2: "5",
                ques_type_3: "8",
                ques_type_4: "0",
              },
              {
                topic_name: "Thermodynamics",
                topic_id: 1003,
                easy: "20",
                medium: "10",
                tough: "30",
                ques_type_1: "2",
                ques_type_2: "3",
                ques_type_3: "1",
                ques_type_4: "4",
              },
              {
                topic_name: "Thermodynamics",
                topic_id: 1005,
                easy: "20",
                medium: "10",
                tough: "30",
                ques_type_1: "2",
                ques_type_2: "3",
                ques_type_3: "1",
                ques_type_4: "4",
              },
            ],
          },
        ],
      },
      {
        subject_name: "Chemistry",
        subject_id: 2,
        easy: "15",
        medium: "25",
        tough: "20",
        ques_type_1: "4",
        ques_type_2: "6",
        ques_type_3: "3",
        ques_type_4: "2",
        chapters: [
          {
            chapter_name: "Physical Chemistry",
            chapter_id: 201,
            easy: "8",
            medium: "12",
            tough: "10",
            ques_type_1: "1",
            ques_type_2: "3",
            ques_type_3: "1",
            ques_type_4: "1",
            topics: [
              {
                topic_name: "Atomic Structure",
                topic_id: 2001,
                easy: "5",
                medium: "7",
                tough: "5",
                ques_type_1: "1",
                ques_type_2: "2",
                ques_type_3: "1",
                ques_type_4: "0",
              },
              {
                topic_name: "Chemical Bonding",
                topic_id: 2002,
                easy: "3",
                medium: "5",
                tough: "5",
                ques_type_1: "0",
                ques_type_2: "1",
                ques_type_3: "0",
                ques_type_4: "1",
              },
            ],
          },
          {
            chapter_name: "Organic Chemistry",
            chapter_id: 202,
            easy: "7",
            medium: "13",
            tough: "10",
            ques_type_1: "2",
            ques_type_2: "3",
            ques_type_3: "2",
            ques_type_4: "1",
            topics: [
              {
                topic_name: "Hydrocarbons",
                topic_id: 2003,
                easy: "4",
                medium: "6",
                tough: "5",
                ques_type_1: "1",
                ques_type_2: "1",
                ques_type_3: "1",
                ques_type_4: "0",
              },
              {
                topic_name: "Alcohols",
                topic_id: 2004,
                easy: "3",
                medium: "7",
                tough: "5",
                ques_type_1: "1",
                ques_type_2: "2",
                ques_type_3: "1",
                ques_type_4: "1",
              },
            ],
          },
        ],
      },
      {
        subject_name: "Biology",
        subject_id: 3,
        easy: "18",
        medium: "16",
        tough: "12",
        ques_type_1: "5",
        ques_type_2: "7",
        ques_type_3: "2",
        ques_type_4: "4",
        chapters: [
          {
            chapter_name: "Cell Biology",
            chapter_id: 301,
            easy: "10",
            medium: "8",
            tough: "6",
            ques_type_1: "2",
            ques_type_2: "3",
            ques_type_3: "1",
            ques_type_4: "1",
            topics: [
              {
                topic_name: "Cell Structure",
                topic_id: 3001,
                easy: "6",
                medium: "4",
                tough: "2",
                ques_type_1: "1",
                ques_type_2: "2",
                ques_type_3: "0",
                ques_type_4: "0",
              },
              {
                topic_name: "Cell Cycle",
                topic_id: 3002,
                easy: "4",
                medium: "4",
                tough: "4",
                ques_type_1: "1",
                ques_type_2: "1",
                ques_type_3: "1",
                ques_type_4: "1",
              },
            ],
          },
          {
            chapter_name: "Genetics",
            chapter_id: 302,
            easy: "8",
            medium: "8",
            tough: "6",
            ques_type_1: "3",
            ques_type_2: "4",
            ques_type_3: "1",
            ques_type_4: "3",
            topics: [
              {
                topic_name: "Mendelian Genetics",
                topic_id: 3003,
                easy: "5",
                medium: "4",
                tough: "3",
                ques_type_1: "1",
                ques_type_2: "2",
                ques_type_3: "0",
                ques_type_4: "1",
              },
              {
                topic_name: "Molecular Genetics",
                topic_id: 3004,
                easy: "3",
                medium: "4",
                tough: "3",
                ques_type_1: "2",
                ques_type_2: "2",
                ques_type_3: "1",
                ques_type_4: "2",
              },
            ],
          },
        ],
      },
      {
        subject_name: "Maths",
        subject_id: 4,
        easy: "22",
        medium: "14",
        tough: "14",
        ques_type_1: "7",
        ques_type_2: "5",
        ques_type_3: "3",
        ques_type_4: "2",
        chapters: [
          {
            chapter_name: "Algebra",
            chapter_id: 401,
            easy: "10",
            medium: "7",
            tough: "6",
            ques_type_1: "2",
            ques_type_2: "2",
            ques_type_3: "1",
            ques_type_4: "1",
            topics: [
              {
                topic_name: "Quadratic Equations",
                topic_id: 4001,
                easy: "4",
                medium: "2",
                tough: "1",
                ques_type_1: "1",
                ques_type_2: "0",
                ques_type_3: "0",
                ques_type_4: "0",
              },
              {
                topic_name: "Sequences and Series",
                topic_id: 4002,
                easy: "6",
                medium: "5",
                tough: "5",
                ques_type_1: "1",
                ques_type_2: "2",
                ques_type_3: "1",
                ques_type_4: "1",
              },
            ],
          },
          {
            chapter_name: "Calculus",
            chapter_id: 402,
            easy: "12",
            medium: "7",
            tough: "8",
            ques_type_1: "5",
            ques_type_2: "3",
            ques_type_3: "2",
            ques_type_4: "1",
            topics: [
              {
                topic_name: "Limits and Continuity",
                topic_id: 4003,
                easy: "8",
                medium: "4",
                tough: "3",
                ques_type_1: "2",
                ques_type_2: "1",
                ques_type_3: "1",
                ques_type_4: "0",
              },
              {
                topic_name: "Differentiation",
                topic_id: 4004,
                easy: "4",
                medium: "3",
                tough: "5",
                ques_type_1: "3",
                ques_type_2: "2",
                ques_type_3: "1",
                ques_type_4: "1",
              },
            ],
          },
        ],
      },
    ],
  };

  // Helper to get all subject pies
  const getChapterPieData = (subject) =>
    subject.chapters.map((chapter) => ({
      chapter_name: chapter.chapter_name,
      easy: Number(chapter.easy),
      medium: Number(chapter.medium),
      tough: Number(chapter.tough),
      total:
        Number(chapter.easy) + Number(chapter.medium) + Number(chapter.tough),
    }));

  // For each subject, get chapters for Pie
  const physicsData = getChapterPieData(apiData.subjects[0]);
  const chemistryData = getChapterPieData(apiData.subjects[1]);
  const biologyData = getChapterPieData(apiData.subjects[2]);
  const mathsData = getChapterPieData(apiData.subjects[3]);

  // For a Big Pie, maybe show subject summary
  const subjectsPieData = apiData.subjects.map((subj) => ({
    subject_name: subj.subject_name,
    easy: Number(subj.easy),
    medium: Number(subj.medium),
    tough: Number(subj.tough),
    total: Number(subj.easy) + Number(subj.medium) + Number(subj.tough),
  }));

  return (
    <div className="main-flex-container-r">
      <div className="main-big-div-r">
        <SingleBigPie
          dataList={subjectsPieData}
          labelField="subject_name"
          chartTitle="Subject-wise Distribution"
          width="650px"
          height="400px"
        />
      </div>
      <div className="main-small-row-r">
        <div className="small-div-r">
          <SmallPie
            dataList={physicsData}
            labelField="chapter_name"
            chartTitle="Physics Chapters"
            width="320px"
            height="220px"
          />
        </div>
        <div className="small-div-r">
          <SmallPie
            dataList={chemistryData}
            labelField="chapter_name"
            chartTitle="Chemistry Chapters"
            width="320px"
            height="220px"
          />
        </div>
        <div className="small-div-r">
          <SmallPie
            dataList={biologyData}
            labelField="chapter_name"
            chartTitle="Biology Chapters"
            width="320px"
            height="220px"
          />
        </div>
        {/* Add more for Maths if you want */}
        {/* <div className="small-div-r">
          <SmallPie
            dataList={mathsData}
            labelField="chapter_name"
            chartTitle="Maths Chapters"
            width="320px"
            height="220px"
          />
        </div> */}
      </div>
    </div>
  );
}

export default POP;
